webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SERVER_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROWS_PER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOP_DEFAULT_CONFIG; });
var SERVER_URL = 'https://tek.atysoft.ro';
// export const SERVER_URL = 'http://tek.test';
var ROWS_PER_PAGE = 25;
var TOP_DEFAULT_CONFIG = {
  pullText: 'Trage în jos pentru reîncărcare', // The text is displayed when you pull down
  triggerText: 'Ridică degetul pentru reîncărcare', // The text that appears when the trigger distance is pulled down
  loadingText: 'Se încarcă...', // The text in the load
  doneText: '', // Load the finished text
  failText: 'Eroare la reîncărcare', // Load failed text
  loadedStayTime: 1, // Time to stay after loading ms
  stayDistance: 50, // Trigger the distance after the refresh
  triggerDistance: 70 // Pull down the trigger to trigger the distance
};

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(62);



var axiosRequest = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  timeout: 10000
});

axiosRequest.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.message.includes('Network Error') || error.code === 'ECONNABORTED') {
    __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'NoInternetConnection' });
  }
  throw error;
});

/* harmony default export */ __webpack_exports__["a"] = (axiosRequest);

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);


var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/* harmony default export */ __webpack_exports__["a"] = (bus);

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutocompleteSelector_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e8281d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutocompleteSelector_vue__ = __webpack_require__(289);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutocompleteSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e8281d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutocompleteSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__ = __webpack_require__(198);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73457628_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__ = __webpack_require__(299);
function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73457628_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__visits__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__employees__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__machines__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visit_actions__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__agencies__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__clients__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__clientsLocations__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__products__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__stock__ = __webpack_require__(320);

















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

function isQuotaExceeded(e) {
  var quotaExceeded = false;
  if (e) {
    if (e.code) {
      switch (e.code) {
        case 22:
          quotaExceeded = true;
          break;
        case 1014:
          // Firefox
          if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
            quotaExceeded = true;
          }
          break;
      }
    } else if (e.number === -2147024882) {
      // Internet Explorer 8
      quotaExceeded = true;
    }
  }
  return quotaExceeded;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({

  strict: true,

  modules: {
    visits: __WEBPACK_IMPORTED_MODULE_5__visits__["a" /* default */],
    employees: __WEBPACK_IMPORTED_MODULE_6__employees__["a" /* default */],
    machines: __WEBPACK_IMPORTED_MODULE_7__machines__["a" /* default */],
    visitActions: __WEBPACK_IMPORTED_MODULE_8__visit_actions__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */],
    agencies: __WEBPACK_IMPORTED_MODULE_10__agencies__["a" /* default */],
    clients: __WEBPACK_IMPORTED_MODULE_11__clients__["a" /* default */],
    clientsLocations: __WEBPACK_IMPORTED_MODULE_12__clientsLocations__["a" /* default */],
    products: __WEBPACK_IMPORTED_MODULE_13__products__["a" /* default */],
    stock: __WEBPACK_IMPORTED_MODULE_14__stock__["a" /* default */]
  },

  state: {
    user: null,
    isMobile: false,
    screenSize: null,
    centerViewVertical: false,
    pageTitle: '',
    token: null,
    fromPage: null
  },

  actions: {
    LOAD_USER: function LOAD_USER(_ref) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* SERVER_URL */] + '/api/user').then(function (response) {
          return response.data;
        }).then(function (response) {
          commit('USER', response);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    USER_EVENT: function USER_EVENT(_ref2, name) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].post('/api/event', { name: name });
    },
    LOGIN: function LOGIN(_ref3, data) {
      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* SERVER_URL */] + '/api/login', data).then(function (response) {
          commit('TOKEN', response.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },

  mutations: {
    USER: function USER(state, payload) {
      this.state.user = payload;
    },
    SCREEN_SIZE: function SCREEN_SIZE(state, payload) {
      this.state.screenSize = payload;
    },
    IS_MOBILE: function IS_MOBILE(state, payload) {
      this.state.isMobile = payload;
    },
    CENTER_VIEW_VERTICAL: function CENTER_VIEW_VERTICAL(state, payload) {
      this.state.centerViewVertical = payload;
    },
    PAGE_TITLE: function PAGE_TITLE(state, payload) {
      this.state.pageTitle = payload;
    },
    TOKEN: function TOKEN(state, payload) {
      state.token = payload;
      try {
        payload ? localStorage.setItem('token', payload) : localStorage.removeItem('token');
      } catch (error) {
        if (isQuotaExceeded(error)) {
          console.log('Not enough storage');
        }
      }
      __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].defaults.headers.common.Authorization = 'Bearer ' + payload;
    },
    FROM_PAGE: function FROM_PAGE(state, payload) {
      this.state.fromPage = payload;
    }
  },

  getters: {}
}));

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SettingsView__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NotFoundView__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_VisitsView__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VisitView__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LoginView__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_MachinesReportsView__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ReportActionsView__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_NoInternetConnectionView__ = __webpack_require__(303);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

function createRouter() {
  var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({

    routes: [{
      path: '/',
      name: 'Visits',
      meta: {
        title: 'Vizite'
      },
      component: __WEBPACK_IMPORTED_MODULE_5__components_VisitsView__["a" /* default */]
    }, {
      path: '/visit/:id',
      name: 'Visit',
      meta: {
        title: ''
      },
      component: __WEBPACK_IMPORTED_MODULE_6__components_VisitView__["a" /* default */]
    }, {
      path: '/reports-machine-history/:machineId?',
      name: 'MachinesReports',
      meta: {
        title: 'Istoric Aparate'
      },
      component: __WEBPACK_IMPORTED_MODULE_8__components_MachinesReportsView__["a" /* default */]
    }, {
      path: '/reports-actions',
      name: 'ReportActions',
      meta: {
        title: 'Acțiuni de făcut'
      },
      component: __WEBPACK_IMPORTED_MODULE_9__components_ReportActionsView__["a" /* default */]
    }, {
      path: '/settings',
      name: 'Settings',
      meta: {
        title: 'Setări'
      },
      component: __WEBPACK_IMPORTED_MODULE_3__components_SettingsView__["a" /* default */]
    },
    // Global redirect for 404
    {
      path: '*',
      redirect: '/404'
    }, {
      path: '/404',
      name: 'NotFound',
      component: __WEBPACK_IMPORTED_MODULE_4__components_NotFoundView__["a" /* default */]
    }, {
      path: '/503',
      name: 'NoInternetConnection',
      component: __WEBPACK_IMPORTED_MODULE_10__components_NoInternetConnectionView__["a" /* default */]
    }, {
      path: '/login',
      name: 'Login',
      meta: {
        title: 'Login'
      },
      component: __WEBPACK_IMPORTED_MODULE_7__components_LoginView__["a" /* default */]
    }]

  });

  function isQuotaExceeded(e) {
    var quotaExceeded = false;
    if (e) {
      if (e.code) {
        switch (e.code) {
          case 22:
            quotaExceeded = true;
            break;
          case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
              quotaExceeded = true;
            }
            break;
        }
      } else if (e.number === -2147024882) {
        // Internet Explorer 8
        quotaExceeded = true;
      }
    }
    return quotaExceeded;
  }

  router.beforeEach(function (to, from, next) {
    if (to.path !== '/login' && to.name !== 'NoInternetConnection' && from.name !== 'NoInternetConnection') {
      if (checkAuthUser()) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('PAGE_TITLE', to.meta.title);
        if (from.name !== null) {
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('FROM_PAGE', from.path);
          try {
            localStorage.setItem('fromPage', from.path);
          } catch (error) {
            if (isQuotaExceeded(error)) {
              console.log('Not enough storage');
            }
          }
        } else {
          var fromPage = localStorage.getItem('fromPage');
          if (fromPage) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('FROM_PAGE', fromPage);
          } else {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('FROM_PAGE', 'Visits');
          }
        }
        document.title = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.pageTitle + ' | TEK';
        next();
      } else {
        next('login');
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('PAGE_TITLE', to.meta.title);
      document.title = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.pageTitle + ' | TEK';
      next();
    }
  });

  function checkAuthUser() {
    var token = localStorage.getItem('token');

    if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.token) {
      return true;
    } else if (token) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('TOKEN', token);
      return true;
    } else {
      return false;
    }
  }

  return router;
}

/* harmony default export */ __webpack_exports__["a"] = (createRouter());

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoaded: false,
      errorMessage: null
    };
  },


  computed: {
    watchLoader: {
      get: function get() {
        if (this.isLoaded) {
          this.$store.commit('CENTER_VIEW_VERTICAL', false);
        } else {
          this.$store.commit('CENTER_VIEW_VERTICAL', true);
        }
      }
    }
  },

  methods: {
    onLogout: function onLogout() {
      this.$store.commit('TOKEN', null);
      this.$router.push({ name: 'Login' });
    }
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch('LOAD_USER').then(function () {
      _this.isLoaded = true;
    }).catch(function () {
      _this.isLoaded = true;
      _this.errorMessage = 'Cannot load user information. Please contact support at support@gosnippet.com';
    });
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VisitCard__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActionSelector__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AutocompleteSelector__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_pull_to__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_pull_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_pull_to__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VisitCard: __WEBPACK_IMPORTED_MODULE_2__VisitCard__["a" /* default */],
    ActionSelector: __WEBPACK_IMPORTED_MODULE_3__ActionSelector__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default.a,
    AutocompleteSelector: __WEBPACK_IMPORTED_MODULE_7__AutocompleteSelector__["a" /* default */],
    PullTo: __WEBPACK_IMPORTED_MODULE_8_vue_pull_to___default.a
  },

  data: function data() {
    return {
      entityName: 'Vizită',
      apiEndpoint: 'visits',
      isLoaded: false,
      dialogData: null,
      startDateModal: false,
      endDateModal: false,
      startDate: null,
      endDate: null,
      agency: null,
      employee: null,
      createdBy: null,
      machine: null,
      client: null,
      status: null,
      action: null,
      startDateDialog: null,
      endDateDialog: null,
      agencyDialog: null,
      employeeDialog: null,
      createdByDialog: null,
      machineDialog: null,
      clientDialog: null,
      statusDialog: null,
      actionDialog: null,
      currentPage: 1,
      filter: {},
      pagination: {},
      rowsPerPage: __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* ROWS_PER_PAGE */],
      totalItems: 0,
      pullDownConfig: __WEBPACK_IMPORTED_MODULE_6__constants__["c" /* TOP_DEFAULT_CONFIG */]
    };
  },


  computed: {
    getTabItems: function getTabItems() {
      var _this = this;

      return function (id) {
        return _this.items.filter(function (f) {
          return f.status === id;
        }).sort(function (a, b) {
          if (new Date(b.created_at) > new Date(a.created_at)) {
            return id ? 1 : -1;
          }
          if (new Date(b.created_at) < new Date(a.created_at)) {
            return id ? -1 : 1;
          }
          return 0;
        });
      };
    },


    tab: {
      get: function get() {
        return this.$store.state.visits.tab;
      },
      set: function set(val) {
        this.$store.commit('visits/TAB', val);
      }
    },

    lastPage: function lastPage() {
      return Math.ceil(this.totalItems / __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* ROWS_PER_PAGE */]);
    },
    isLastPage: function isLastPage() {
      return this.currentPage >= this.lastPage;
    },


    dialog: {
      get: function get() {
        this.startDateDialog = this.startDate;
        this.endDateDialog = this.endDate;
        this.agencyDialog = this.agency;
        this.employeeDialog = this.employee;
        this.createdByDialog = this.createdBy;
        this.machineDialog = this.machine;
        this.clientDialog = this.client;
        this.statusDialog = this.status;
        this.actionDialog = this.action;
        return this.$store.state.visits.filter;
      },
      set: function set(value) {
        this.$store.commit('visits/FILTER', value);
      }
    },

    items: function items() {
      return this.$store.state.visits.data;
    },
    loadedItems: function loadedItems() {
      return this.loadedItems.concat(this.items);
    },
    fields: function fields() {
      return [{
        size: 'sm6',
        label: 'Stare',
        value: 'status',
        type: 'v-select',
        inputType: 'text',
        options: this.$store.state.visits.status,
        required: true
      }, {
        size: 'sm6',
        label: 'Aparat',
        value: 'machine_id',
        itemText: 'idstr',
        type: 'autocomplete-selector',
        required: true,
        apiEndpoint: 'machines'
      }, {
        size: 'sm6',
        label: 'Contor general',
        value: 'counter',
        type: 'v-text-field',
        inputType: 'number',
        required: true
      }, {
        label: 'Note',
        value: 'notes',
        type: 'v-textarea',
        inputType: 'text',
        box: true
      }];
    },


    watchLoader: {
      get: function get() {
        if (this.isLoaded) {
          this.$store.commit('CENTER_VIEW_VERTICAL', false);
        } else {
          this.$store.commit('CENTER_VIEW_VERTICAL', true);
        }
      }
    },

    agencyChip: {
      get: function get() {
        return !!this.agency;
      },
      set: function set(value) {
        if (!value) {
          this.agency = null;
          this.loadItems();
        }
      }
    },

    employeeChip: {
      get: function get() {
        return !!this.employee;
      },
      set: function set(value) {
        if (!value) {
          this.employee = null;
          this.loadItems();
        }
      }
    },

    createdByChip: {
      get: function get() {
        return !!this.createdBy;
      },
      set: function set(value) {
        if (!value) {
          this.createdBy = null;
          this.loadItems();
        }
      }
    },

    machineChip: {
      get: function get() {
        return !!this.machine;
      },
      set: function set(value) {
        if (!value) {
          this.machine = null;
          this.loadItems();
        }
      }
    },

    clientChip: {
      get: function get() {
        return !!this.client;
      },
      set: function set(value) {
        if (!value) {
          this.client = null;
          this.loadItems();
        }
      }
    },

    statusChip: {
      get: function get() {
        return !!this.status;
      },
      set: function set(value) {
        if (!value) {
          this.status = null;
          this.loadItems();
        }
      }
    },

    actionChip: {
      get: function get() {
        return !!this.action;
      },
      set: function set(value) {
        if (!value) {
          this.action = null;
          this.loadItems();
        }
      }
    },

    startDateChip: {
      get: function get() {
        return !!this.startDate;
      },
      set: function set(value) {
        if (!value) {
          this.startDate = null;
          this.loadItems();
        }
      }
    },

    endDateChip: {
      get: function get() {
        return !!this.endDate;
      },
      set: function set(value) {
        if (!value) {
          this.endDate = null;
          this.loadItems();
        }
      }
    }
  },

  created: function created() {
    var _this2 = this;

    this.loadDependencies().then(function () {
      _this2.loadItems();
      _this2.isLoaded = true;
      // this.loadMoreVisits().then(() => { this.isLoaded = true; });
    });
  },


  watch: {
    filter: {
      handler: function handler() {
        var _this3 = this;

        this.isLoaded = false;
        this.loadMoreVisits().then(function (result) {
          _this3.currentPage = result.meta.current_page;
          _this3.isLoaded = true;
        });
      },

      deep: true
    }
  },

  methods: {
    loadItems: function loadItems() {
      this.filter = {
        agency_id: this.agency ? this.agency.id : null,
        employee_id: this.employee ? this.employee.id : null,
        created_by_id: this.createdBy ? this.createdBy.id : null,
        machine_id: this.machine ? this.machine.id : null,
        client_id: this.client ? this.client.id : null,
        status: this.status ? this.status.id : null,
        action_id: this.action ? this.action : null,
        start_date: this.startDate ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss') : null,
        end_date: this.endDate ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss') : null
      };
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this4 = this;

      if (this.isLastPage) {
        $state.loaded();
        $state.complete();
      } else {
        this.loadMoreVisits(true).then(function (result) {
          _this4.currentPage++;
          _this4.totalItems = result.meta.total;
          $state.loaded();
        }).catch(function () {
          $state.complete();
        });
      }
    },
    loadMoreVisits: function loadMoreVisits() {
      var loadMore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.pagination = {
        rowsPerPage: this.rowsPerPage,
        page: this.currentPage
      };
      return this.$store.dispatch('visits/LOAD', { filter: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.filter, this.pagination), loadMore: loadMore });
    },
    loadDependencies: function loadDependencies() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.$store.dispatch('actions/LOAD', { filter: { rowsPerPage: -1 } }), this.$store.dispatch('employees/LOAD', { filter: { rowsPerPage: -1 } }), this.$store.dispatch('agencies/LOAD', { filter: { rowsPerPage: -1 } })]);
    },
    addVisit: function addVisit() {
      this.dialogData = {
        id: null,
        status: 1,
        created_at: __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date()).local().format('YYYY-MM-DD HH:mm:ss')
      };
    },
    onStatusChange: function onStatusChange(value) {
      this.dialogData = value;
    },
    goToVisit: function goToVisit(item) {
      this.$router.push({ name: 'Visit', params: { id: item.id } });
    },
    getActionName: function getActionName(id) {
      return this.$store.getters['actions/action'](id).path;
    },
    filterVisits: function filterVisits() {
      this.startDate = this.startDateDialog;
      this.endDate = this.endDateDialog;
      this.agency = this.agencyDialog;
      this.employee = this.employeeDialog;
      this.createdBy = this.createdByDialog;
      this.machine = this.machineDialog;
      this.client = this.clientDialog;
      this.status = this.statusDialog;
      this.action = this.actionDialog;
      this.loadItems();
      this.dialog = false;
    },
    refresh: function refresh(loaded) {
      this.loadMoreVisits().then(function (res) {
        loaded('done');
      });
    }
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['visit'],
  data: function data() {
    return {};
  },


  methods: {
    filterDate: function filterDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD/MM/YYYY HH:mm');
    }
  }
});

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionSelector_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e2b5390_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionSelector_vue__ = __webpack_require__(287);
function injectStyle (ssrContext) {
  __webpack_require__(278)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e2b5390_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionTree__ = __webpack_require__(279);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ActionTree: __WEBPACK_IMPORTED_MODULE_0__ActionTree__["a" /* default */]
  },

  props: ['value', 'error', 'error-messages', 'errors'],

  data: function data() {
    return {
      editDialog: false
    };
  },


  computed: {
    isMobile: function isMobile() {
      return this.$store.state.isMobile;
    },
    selectedItem: function selectedItem() {
      var value = this.$store.state.actions.selectedItem;
      if (value) {
        this.$emit('input', value.id);
        this.editDialog = false;
      }
      return value;
    },
    path: function path() {
      if (this.value) {
        return this.$store.getters['actions/action'](this.value).path;
      } else {
        return '';
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tree_vue__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Tree: __WEBPACK_IMPORTED_MODULE_0__Tree_vue__["a" /* default */]
  },
  props: ['data', 'mode'],
  data: function data() {
    return {
      editDialogData: '',
      editDialog: false,
      processing: false,
      errorMessages: [],
      errorMessageGeneric: null
    };
  },


  computed: {
    selectedItem: function selectedItem() {
      return this.$store.state.actions.selectedItem;
    },
    isAddMode: function isAddMode() {
      return this.editDialogData.id === null;
    },


    filter: {
      get: function get() {},
      set: function set(value) {
        this.$store.commit('actions/FILTER', value);
      }
    }
  },

  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$on('action', function (payLoad) {
      _this.initErrorMessage();
      if (payLoad.id) {
        _this.editDialog = true;
        _this.editDialogData = {
          id: payLoad.id,
          name: payLoad.name
        };
      }
    });
  },


  methods: {
    initErrorMessage: function initErrorMessage() {
      this.errorMessages = [];
      this.errorMessageGeneric = null;
    },
    onAction: function onAction(event) {
      var _this2 = this;

      switch (event) {
        case 'add':
          this.initErrorMessage();
          this.editDialog = true;
          this.editDialogData = { id: null, name: '' };
          break;
        case 'duplicate':
          break;
        case 'edit':
          this.initErrorMessage();
          if (this.selectedItem.id) {
            this.editDialog = true;
            this.editDialogData = {
              id: this.selectedItem.id,
              name: this.selectedItem.name
            };
          }
          break;
        case 'delete':
          var deletedItem = this.selectedItem.name;
          __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit('confirmation-dialog-show', {
            title: 'Confirmare ștergere',
            text: 'Sunte\u021Bi sigur c\u0103 dori\u021Bi s\u0103 sterge\u021Bi ac\u021Biunea ' + this.selectedItem.name + '?',
            actionButton: 'Sterge',
            action: function action() {
              _this2.$store.dispatch('actions/DELETE', _this2.selectedItem.id).then(function () {
                __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit('toast-message-show', {
                  text: 'Ac\u021Biunea ' + deletedItem + ' a fost \u0219tears\u0103.'
                });
              }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit('toast-message-show', {
                  error: true,
                  text: 'A intervenit o eroare la \u0219tergerea ac\u021Biunii ' + deletedItem + '.'
                });
              });
            }
          });
          break;
        default:
          break;
      }
    },
    onDialogSave: function onDialogSave() {
      var _this3 = this;

      if (this.isAddMode) {
        this.processing = true;
        this.$store.dispatch('actions/ADD', {
          name: this.editDialogData.name,
          parent_id: this.selectedItem ? this.selectedItem.id : 0
        }).then(function (response) {
          _this3.processing = false;
          _this3.editDialog = false;
        }).catch(function (error) {
          if (error.response.data.errors) {
            _this3.processing = false;
            _this3.errorMessages = error.response.data.errors;
          } else {
            _this3.processing = false;
            _this3.errorMessageGeneric = 'A apărut o eroare la salvare.';
          }
        });
      } else {
        this.processing = true;
        this.$store.dispatch('actions/EDIT', {
          id: this.selectedItem.id,
          name: this.editDialogData.name,
          parent_id: this.selectedItem.parent_id
        }).then(function (response) {
          _this3.processing = false;
          _this3.editDialog = false;
        }).catch(function (error) {
          if (error.response.data.errors) {
            _this3.processing = false;
            _this3.errorMessages = error.response.data.errors;
          } else {
            _this3.processing = false;
            _this3.errorMessageGeneric = 'A apărut o eroare la salvare.';
          }
        });
      }
    },
    onSelect: function onSelect() {
      this.$store.commit('actions/SELECT', this.node);
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TreeNode__ = __webpack_require__(282);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TreeNode: __WEBPACK_IMPORTED_MODULE_0__TreeNode__["a" /* default */]
  },
  props: ['data', 'mode']
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['node', 'mode'],
  name: 'TreeNode',
  data: function data() {
    return {
      expanded: false
    };
  },

  computed: {
    hasChildren: function hasChildren() {
      return this.node.children && this.node.children.length;
    }
  },
  methods: {
    onSelect: function onSelect() {
      if (this.hasChildren) {
        this.expanded = !this.expanded;
        if (this.mode === 'select') {
          return;
        }
      }

      if (this.$store.state.actions.selectedItem && this.node.id === this.$store.state.actions.selectedItem.id) {
        this.$store.commit('actions/SELECT', null);
      } else {
        this.$store.commit('actions/SELECT', this.node);
      }
    },
    onEdit: function onEdit() {
      if (this.mode === 'select') return;
      this.$store.commit('actions/SELECT', this.node);
      __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit('action', this.node);
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'error', 'errors', 'itemText', 'itemValue', 'field', 'data', 'items', 'label', 'required', 'returnObject', 'apiEndpoint'],

  data: function data() {
    return {
      search: null,
      isLoaded: true,
      localItems: []
    };
  },


  watch: {
    search: function search(val) {
      var _this = this;

      // Skip ajax call if search term allready in list
      if (this.data && this.data[this.keyValueObject] && this.data[this.keyValueObject][this.itemText] === val) return;

      // Skip ajax call if selection has been made
      if (this.listItems.some(function (item) {
        return item[_this.itemText] === val;
      })) return;

      this.loadItems();
    }
  },

  computed: {
    keyValueObject: function keyValueObject() {
      return this.field ? this.field.value.replace('_id', '') : null;
    },
    listItems: function listItems() {
      return this.items ? this.items : this.localItems;
    },
    endpoint: function endpoint() {
      return this.field ? this.field.apiEndpoint : this.apiEndpoint;
    },


    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },

  created: function created() {
    // Clear cached object
    this.$store.commit(this.endpoint + '/' + this.endpoint.toUpperCase(), []);

    // Check if you are in edit mode and we have the object cached
    if (this.data && this.data.id && this.data[this.keyValueObject]) {
      this.localItems = [this.data[this.keyValueObject]];
    }
  },


  methods: {
    loadItems: function loadItems() {
      var _this2 = this;

      if (!this.search) return;
      this.isLoaded = false;
      this.$store.dispatch(this.endpoint + '/LOAD', { filter: { rowsPerPage: 25, search: this.search } }).then(function (result) {
        _this2.localItems = result.data;
        _this2.isLoaded = true;
      });
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bus__ = __webpack_require__(14);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      isLoaded: false,
      processing: false,
      headers: [{
        text: 'Data',
        align: 'left',
        value: 'created_at',
        format: function format(item) {
          return '<span class="v-chip white--text theme--dark ' + _this.$store.getters['visitActions/status'](item.status).color + '"><span class="v-chip__content">' + _this.$store.getters['visitActions/status'](item.status).name + '</span></span>' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.created_at).format('DD/MM/YYYY HH:mm') + '<br><b>' + item.path + ' (' + item.duration + ' minute)</b>';
        },
        searchable: true
      }],
      entityName: 'Acțiune',

      actions: [{ name: 'Editează', color: '', event: 'edit' }, { name: 'Șterge', event: 'delete', color: 'red' }]
    };
  },

  computed: {
    dialogData: {
      get: function get() {
        return this.$store.state.actions.dialog;
      },
      set: function set(value) {
        this.$store.commit('actions/DIALOG', value);
      }
    },

    dialogDataVisit: {
      get: function get() {
        return this.$store.state.visits.dialog;
      },
      set: function set(value) {
        this.$store.commit('visits/DIALOG', value);
      }
    },

    visit: function visit() {
      var _this2 = this;

      return this.$store.state.visits.data.find(function (f) {
        return f.id === ~~_this2.$route.params.id;
      });
    },
    visitActions: function visitActions() {
      return this.$store.state.visitActions.data;
    },
    fields: function fields() {
      var _this3 = this;

      return [{
        size: 'sm12',
        label: 'Stare',
        value: 'status',
        type: 'v-select',
        inputType: 'text',
        options: this.$store.state.visitActions.status,
        required: true
      }, {
        size: 'sm12',
        label: 'Acțiune',
        value: 'action_id',
        type: 'action-selector'
      }, {
        size: 'sm12',
        label: 'Durata (min)',
        value: 'duration',
        type: 'v-text-field',
        inputType: 'number',
        required: true
      }, {
        size: 'sm12',
        label: 'Piesă',
        value: this.getSelectedActionProductType === 'stock' ? 'stock_id' : 'product_id',
        type: 'product-search',
        inputType: 'text',
        hide: function hide(data) {
          if (data.action_id) {
            var selectedAction = _this3.$store.getters['actions/action'](data.action_id);
            if (selectedAction) {
              return data.status === 1 && (selectedAction.path.includes('INLOCUI') || selectedAction.path.includes('DEMONTA') || selectedAction.path.includes('MONTA'));
            }
          }
          return false;
        },
        apiEndpoint: this.getSelectedActionProductType,
        required: true
      }];
    },
    getSelectedActionProductType: function getSelectedActionProductType() {
      if (this.$store.state.actions.selectedItem) {
        if (this.path.includes('INLOCUI') || this.path.includes('MONTA') && !this.path.includes('DEMONTA')) {
          return 'stock';
        }
        return 'products';
      }
    },
    shouldShowProductField: function shouldShowProductField() {
      if (this.$store.state.actions.selectedItem) {
        return this.path.includes('INLOCUI') || this.path.includes('DEMONTA') || this.path.includes('MONTA');
      }
      return false;
    },
    fieldsVisit: function fieldsVisit() {
      return [{
        size: 'sm6',
        label: 'Stare',
        value: 'status',
        type: 'v-select',
        inputType: 'text',
        options: this.$store.state.visits.status,
        required: true
      }, {
        size: 'sm6',
        label: 'Aparat',
        value: 'machine_id',
        itemText: 'idstr',
        type: 'autocomplete-selector',
        required: true,
        apiEndpoint: 'machines'
      }, {
        size: 'sm6',
        label: 'Contor general',
        value: 'counter',
        type: 'v-text-field',
        inputType: 'number',
        required: true
      }, {
        label: 'Note',
        value: 'notes',
        type: 'v-textarea',
        inputType: 'text',
        box: true
      }];
    },
    searchableColumns: function searchableColumns() {
      return this.headers.filter(function (i) {
        return i.searchable !== false;
      });
    },


    watchLoader: {
      get: function get() {
        if (this.isLoaded) {
          this.$store.commit('CENTER_VIEW_VERTICAL', false);
        } else {
          this.$store.commit('CENTER_VIEW_VERTICAL', true);
        }
      }
    },

    path: function path() {
      return this.$store.state.actions.selectedItem ? this.$store.getters['actions/action'](this.$store.state.actions.selectedItem.id).path : '';
    }
  },

  created: function created() {
    var _this4 = this;

    this.loadDependencies().then(function () {
      _this4.loadItem();
    });
  },


  methods: {
    loadItem: function loadItem() {
      var _this5 = this;

      this.$store.dispatch('visits/LOAD', { id: this.$route.params.id, filter: null }).then(function () {
        _this5.$store.dispatch('clientsLocations/LOAD_ONE', _this5.visit.client_location_id).then(function () {
          _this5.isLoaded = true;
        });
      });
    },
    loadDependencies: function loadDependencies() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.$store.dispatch('actions/LOAD', { filter: { rowsPerPage: -1 } }), this.$store.dispatch('employees/LOAD', { filter: { rowsPerPage: -1 } }), this.$store.dispatch('agencies/LOAD', { filter: { rowsPerPage: -1 } }), this.$store.dispatch('LOAD_USER')]);
    },
    fullName: function fullName(employee) {
      return employee.firstname + ' ' + employee.lastname;
    },
    filterDate: function filterDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD/MM/YYYY HH:mm');
    },
    onRowAction: function onRowAction(event) {
      var _this6 = this;

      switch (event.name) {
        case 'edit':
          this.$store.commit('actions/FILTER', '');
          this.$store.commit('actions/SELECT', null);
          var visit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, event.data);
          visit.visit_id = this.visit.id;
          delete visit.created_at;
          delete visit.updated_at;
          this.$store.commit('actions/SELECT', visit.action);
          this.dialogData = visit;
          break;
        case 'add':
          this.onActionAdd();
          break;
        case 'delete':
          __WEBPACK_IMPORTED_MODULE_3__bus__["a" /* default */].$emit('confirmation-dialog-show', {
            title: 'Confirmare ștergere',
            text: 'Sunte\u021Bi sigur c\u0103 dori\u021Bi s\u0103 \u0219terge\u021Bi ac\u021Biunea ' + event.data.action.name + '?',
            actionButton: 'Șterge',
            action: function action() {
              _this6.$store.dispatch('visitActions/DELETE', event.data.id).then(function () {
                __WEBPACK_IMPORTED_MODULE_3__bus__["a" /* default */].$emit('toast-message-show', {
                  text: 'Ac\u021Biunea ' + event.data.action.name + '  a fost \u0219tears\u0103.'
                });
              }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_3__bus__["a" /* default */].$emit('toast-message-show', {
                  error: true,
                  text: 'A intervenit o eroare la \u0219tergerea ac\u021Biunii ' + event.data.action.name + '.'
                });
              });
            }
          });
          break;
      }
    },
    onAction: function onAction(event) {
      switch (event) {
        case 'edit':
          this.dialogDataVisit = this.visit;
          break;
        case 'visits':
          this.$router.push({ path: this.$store.state.fromPage });
          break;
      }
    },
    onStatusChange: function onStatusChange(value) {
      this.dialogData = value;
    },
    onStatusChangeVisit: function onStatusChangeVisit(value) {
      this.dialogDataVisit = value;
    },
    onActionAdd: function onActionAdd() {
      this.$store.commit('actions/FILTER', '');
      this.$store.commit('actions/SELECT', null);
      this.dialogData = {
        id: null,
        visit_id: this.visit.id,
        status: 1
      };
    },
    closeVisit: function closeVisit() {
      var _this7 = this;

      var visitData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.visit);
      visitData.status = 1;
      delete visitData.created_at;
      delete visitData.updated_at;
      this.processing = true;
      this.$store.dispatch('visits/EDIT', visitData).then(function (response) {
        _this7.processing = false;
        _this7.$router.push({ path: _this7.$store.state.fromPage });
      }).catch(function (error) {
        if (error.response.data.errors) {
          _this7.processing = false;
          _this7.errorMessages = error.response.data.errors;
        } else {
          _this7.processing = false;
          _this7.errorMessageGeneric = 'A apărut o eroare la salvare.';
        }
      });
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      errorMessages: [],
      errorMessageGeneric: null,
      email: '',
      password: '',
      processing: false
    };
  },
  created: function created() {
    this.$store.commit('CENTER_VIEW_VERTICAL', true);
  },


  methods: {
    login: function login() {
      var _this = this;

      var loginData = { email: this.email, password: this.password };
      this.$store.dispatch('LOGIN', loginData).then(function (response) {
        _this.processing = false;
        _this.$router.push({ name: 'Visits' });
      }).catch(function (error) {
        if (error.response.data.errors) {
          _this.processing = false;
          _this.errorMessages = error.response.data.errors;
        } else {
          _this.processing = false;
          _this.errorMessageGeneric = 'Email sau parolă incorectă';
        }
      });
    },
    dialogErrorMessage: function dialogErrorMessage(field) {
      if (field in this.errorMessages) {
        return this.errorMessages[field];
      }
      return [];
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AutocompleteSelector__ = __webpack_require__(38);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_2__DataTable__["default"],
    AutocompleteSelector: __WEBPACK_IMPORTED_MODULE_3__AutocompleteSelector__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      search: '',
      isLoaded: false,
      machine: null,
      loading: true,

      actions: [{ name: 'Detalii vizită', color: '', event: 'open' }],

      headers: [{
        text: 'Data',
        align: 'left',
        value: 'created_at',
        format: function format(item) {
          return '<span class="v-chip white--text theme--dark ' + _this.$store.getters['visitActions/status'](item.status).color + '"><span class="v-chip__content">' + _this.$store.getters['visitActions/status'](item.status).name + '</span></span>\n                    ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.created_at).format('DD/MM/YYYY HH:mm') + '<br>\n                    <strong>' + item.path + ' (' + item.duration + ' minute)</strong><br>\n                    <strong>Angajat:</strong> ' + item.visit.employee.name + '<br>\n                    <strong>Client:</strong> ' + item.visit.machine.client_location.client.name + '<br>\n                    <strong>Loca\u021Bie client:</strong> ' + item.visit.machine.client_location.name;
        }
      }],
      filter: {},
      items: []
    };
  },


  computed: {
    hasItems: function hasItems() {
      return !(this.items.length === 0 && !this.loading && this.$route.params.machineId);
    },


    watchLoader: {
      get: function get() {
        if (this.$route.params.machineId) {
          if (!this.loading) {
            this.$store.commit('CENTER_VIEW_VERTICAL', false);
          } else {
            this.$store.commit('CENTER_VIEW_VERTICAL', true);
          }
        }
      }
    }
  },

  created: function created() {
    var _this2 = this;

    this.$store.commit('CENTER_VIEW_VERTICAL', false);
    if (this.$route.params.machineId) {
      this.loadDependencies().then(function () {
        _this2.loadItems();
        _this2.isLoaded = true;
      });
    } else {
      this.loadItems();
      this.isLoaded = true;
    }
  },


  watch: {
    machine: function machine(val) {
      if (val) {
        this.$router.push({ name: 'MachinesReports', params: { machineId: val.id } });
      }
    }
  },

  methods: {
    staticItems: function staticItems(values) {
      var _this3 = this;

      this.items = values ? values.map(function (item) {
        if (item.action && item.action.id) {
          item.path = _this3.$store.getters['actions/action'](item.action.id).path;
        } else {
          item.path = '- nedefinit -';
        }
        return item;
      }) : [];
    },
    loadItems: function loadItems() {
      var _this4 = this;

      this.filter = {
        machine_id: this.machine ? this.machine.id : this.$route.params.machineId ? this.$route.params.machineId : null
      };
      if (this.filter.machine_id) {
        this.machine = this.$store.state.machines.data.find(function (f) {
          return f.id === ~~_this4.$route.params.machineId;
        });
      }
    },
    loadDependencies: function loadDependencies() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.$store.dispatch('machines/LOAD_ONE', ~~this.$route.params.machineId), this.$store.dispatch('actions/LOAD', { filter: { rowsPerPage: -1 } })]);
    },
    onRowAction: function onRowAction(event) {
      switch (event.name) {
        case 'open':
          this.$router.push({ name: 'Visit', params: { id: event.data.visit_id } });
          break;
      }
    },
    onLoading: function onLoading(loading) {
      this.loading = loading;
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['items', 'headers', 'entityName', 'isLoaded', 'actions', 'filter', 'apiEndpoint', 'staticData'],

  data: function data() {
    return {
      search: '',
      newData: {
        id: null
      },
      loading: true,
      pagination: {},
      rowsPerPageItems: [5, 10, 25, 50, { 'text': 'Tot', 'value': -1 }],
      totalItems: 0
    };
  },


  watch: {
    pagination: {
      handler: function handler() {
        this.loadItems();
      },

      deep: true
    },

    filter: function filter() {
      this.loadItems();
    }
  },

  computed: {
    searchableColumns: function searchableColumns() {
      return this.headers.filter(function (i) {
        return i.searchable !== false;
      });
    },
    hasPagination: function hasPagination() {
      return this.totalItems > __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROWS_PER_PAGE */];
    }
  },

  created: function created() {
    this.pagination.rowsPerPage = __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ROWS_PER_PAGE */];
  },


  methods: {
    loadItems: function loadItems() {
      var _this = this;

      if (this.apiEndpoint) {
        this.loading = true;
        this.$emit('loading', this.loading && this.totalItems === 0);
        this.$store.dispatch(this.apiEndpoint + '/LOAD', { filter: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ search: this.search }, this.filter, this.pagination) }).then(function (result) {
          if (_this.staticData) {
            _this.$emit('staticItems', result.data);
          }
          _this.totalItems = result.meta.total;
          _this.loading = false;
          _this.$emit('loading', _this.loading && _this.totalItems === 0);
        });
      } else {
        this.loading = false;
        this.pagination.rowsPerPage = -1;
      }
    },
    tableToggleRowExpand: function tableToggleRowExpand(props) {
      props.expanded = !props.expanded;
    },
    onAction: function onAction(event, item) {
      var eventData = {
        name: event,
        data: item
      };
      this.$emit('action', eventData);
    },
    displayRowData: function displayRowData(props, header) {
      if (props.item[header.value] || props.item[header.value] === 0) {
        if (header.nestedValue) {
          var nestedValues = header.nestedValue.split('.');
          var rowData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.item);
          nestedValues.forEach(function (prop) {
            rowData = rowData[prop];
          });
          return rowData;
        } else if (header.format) {
          return header.format(props.item);
        } else {
          return props.item[header.value];
        }
      }
      return '';
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataTable__ = __webpack_require__(39);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_2__DataTable__["default"]
  },
  data: function data() {
    return {
      search: null,
      isLoaded: false,

      actions: [{ name: 'Detalii vizită', color: '', event: 'open' }],

      headers: [{
        text: 'Data',
        align: 'left',
        value: 'created_at',
        format: function format(item) {
          return __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.created_at).format('DD/MM/YYYY HH:mm') + '<br>\n                    <strong>' + item.path + '</strong><br>\n                    <strong>Client:</strong> ' + item.visit.machine.client_location.client.name + '<br>\n                    <strong>Loca\u021Bie client:</strong> ' + item.visit.machine.client_location.name;
        }
      }],
      filter: {},
      items: []
    };
  },


  computed: {

    watchLoader: {
      get: function get() {
        if (this.isLoaded) {
          this.$store.commit('CENTER_VIEW_VERTICAL', false);
        } else {
          this.$store.commit('CENTER_VIEW_VERTICAL', true);
        }
      }
    }

  },

  created: function created() {
    var _this = this;

    this.isLoaded = false;
    this.loadDependencies().then(function () {
      _this.loadFilter();
    });
  },


  methods: {
    staticItems: function staticItems(values) {
      var _this2 = this;

      this.items = values ? values.map(function (item) {
        if (item.action && item.action.id) {
          item.path = _this2.$store.getters['actions/action'](item.action.id).path;
        } else {
          item.path = '- nedefinit -';
        }
        return item;
      }) : [];
      this.isLoaded = true;
    },
    loadFilter: function loadFilter() {
      this.filter = {
        status: 0
      };
    },
    loadDependencies: function loadDependencies() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.$store.dispatch('actions/LOAD', { filter: { rowsPerPage: -1 } })]);
    },
    onRowAction: function onRowAction(event) {
      switch (event.name) {
        case 'open':
          this.$router.push({ name: 'Visit', params: { id: event.data.visit_id } });
          break;
      }
    }
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    retry: function retry() {
      this.$router.push({ path: this.$store.state.fromPage ? this.$store.state.fromPage : '/' }); // We should redirect to visits page? to the last page
    }
  },

  created: function created() {
    this.$store.commit('CENTER_VIEW_VERTICAL', true);
  }
});

/***/ }),
/* 201 */,
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_Default__ = __webpack_require__(323);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',

  components: {
    LayoutDefault: __WEBPACK_IMPORTED_MODULE_0__components_layouts_Default__["a" /* default */]
  },

  computed: {
    component: function component() {
      if (this.$route.path === '/error') {
        return 'error';
      }
      return 'layout-default';
    }
  },

  created: function created() {
    this.$store.commit('IS_MOBILE', true);
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      drawer: null
    };
  },

  computed: {
    tab: {
      get: function get() {
        return this.$store.state.visits.tab;
      },
      set: function set(val) {
        this.$store.commit('visits/TAB', val);
      }
    },

    items: {
      get: function get() {
        return [{ icon: 'my_location', text: 'Vizite', href: '/' }, { icon: 'history', text: 'Istoric Aparate', href: '/reports-machine-history' }, { icon: 'check_circle_outline', text: 'Acțiuni de făcut', href: '/reports-actions' }, { icon: 'settings', text: 'Setari', href: '/settings' }];
      }
    },

    actions: {
      get: function get() {
        return [{ id: 'edit', text: 'Editează' }];
      }
    },

    pageTitle: function pageTitle() {
      return this.$store.state.pageTitle || this.$router.currentRoute.meta.title;
    }
  },

  methods: {
    navigate: function navigate(href) {
      this.$router.push({ path: href });
    },
    back: function back() {
      this.$router.push({ path: this.$store.state.fromPage });
    },
    onAction: function onAction(type) {
      var _this = this;

      switch (type) {
        case 'edit':
          var visit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$store.state.visits.data.find(function (f) {
            return f.id === ~~_this.$route.params.id;
          }));
          delete visit.created_at;
          delete visit.updated_at;
          this.$store.commit('visits/DIALOG', visit);
          break;
        case 'delete':
          __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit('confirmation-dialog-show', {
            title: 'Confirmare ștergere',
            text: 'Sunte\u021Bi sigur c\u0103 dori\u021Bi s\u0103 \u0219terge\u021Bi vizita?',
            actionButton: 'Șterge',
            action: function action() {
              _this.$store.dispatch('visits/DELETE', _this.$route.params.id).then(function () {
                __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit('toast-message-show', {
                  text: 'Vizita a fost \u0219tears\u0103.'
                });
                _this.$router.push({ path: '/' });
              }).catch(function () {
                __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit('toast-message-show', {
                  error: true,
                  text: 'A intervenit o eroare la \u0219tergerea vizitei.'
                });
              });
            }
          });
          break;
        case 'add':
          this.$store.commit('actions/FILTER', '');
          this.$store.commit('actions/SELECT', null);
          this.$store.commit('actions/DIALOG', { id: null, visit_id: ~~this.$route.params.id, status: 1 });
          break;
        case 'filter':
          this.$store.commit('visits/FILTER', true);
          break;
      };
    }
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: 70
    },

    width: {
      default: 5
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      title: '',
      text: '',
      actionButton: 'Ok',
      action: function action() {}
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on('confirmation-dialog-show', function (message) {
      _this.title = message.title;
      _this.text = _this.nl2br(message.text);
      _this.action = message.action;
      _this.actionButton = message.actionButton;
      _this.dialog = true;
    });
  },


  methods: {
    nl2br: function nl2br(str) {
      var breakTag = '<br />';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    onCancel: function onCancel() {
      this.dialog = false;
    },
    onOk: function onOk() {
      this.action();
      this.dialog = false;
    }
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      messageOn: false,
      message: '',
      error: false
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on('toast-message-show', function (message) {
      _this.message = _this.nl2br(message.text);
      _this.messageOn = true;
      _this.error = message.error || false;
    });
  },


  methods: {
    nl2br: function nl2br(str) {
      var breakTag = '<br />';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionSelector__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DatePicker__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AutocompleteSelector__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductSearch__ = __webpack_require__(338);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ActionSelector: __WEBPACK_IMPORTED_MODULE_1__ActionSelector__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_2__DatePicker__["a" /* default */],
    AutocompleteSelector: __WEBPACK_IMPORTED_MODULE_3__AutocompleteSelector__["a" /* default */],
    ProductSearch: __WEBPACK_IMPORTED_MODULE_4__ProductSearch__["a" /* default */]
  },

  props: ['fields', 'entityName', 'fieldValues', 'apiEndpoint', 'isMobile'],

  data: function data() {
    return {
      errorMessages: [],
      errorMessageGeneric: null,
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.fieldValues),
      processing: false
    };
  },


  computed: {
    dialog: {
      get: function get() {
        return !!this.fieldValues;
      },
      set: function set(value) {
        this.$emit('status', value);
      }
    },

    isEditMode: function isEditMode() {
      return this.data.id !== null;
    }
  },

  methods: {
    shouldShow: function shouldShow(field) {
      if (field.hide) {
        if (field.hide(this.data)) {
          return true;
        } else {
          delete this.data[field.value];
          return false;
        }
      }
      return true;
    },
    dialogErrorMessage: function dialogErrorMessage(field) {
      if (field in this.errorMessages) {
        return this.errorMessages[field];
      }
      return [];
    },
    onDialogSave: function onDialogSave() {
      var _this = this;

      this.errorMessages = [];
      this.processing = true;
      if (this.isEditMode) {
        // edit mode
        this.$store.dispatch(this.apiEndpoint + '/EDIT', this.data).then(function (response) {
          _this.processing = false;
          _this.dialog = false;
        }).catch(function (error) {
          if (error.response.data.errors) {
            _this.processing = false;
            _this.errorMessages = error.response.data.errors;
          } else {
            _this.processing = false;
            _this.errorMessageGeneric = 'A apărut o eroare la salvare.';
          }
        });
      } else {
        // add mode
        this.$store.dispatch(this.apiEndpoint + '/ADD', this.data).then(function (response) {
          _this.processing = false;
          _this.dialog = false;
          if (_this.apiEndpoint === 'visits') {
            _this.$router.push({ name: 'Visit', params: { id: response.data.id } });
          }
        }).catch(function (error) {
          if (error.response.data.errors) {
            _this.processing = false;
            _this.errorMessages = error.response.data.errors;
          } else {
            _this.processing = false;
            _this.errorMessageGeneric = 'A apărut o eroare la salvare.';
          }
        });
      }
    }
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'label'],

  data: function data() {
    return {
      dateModel: this.filterDate(this.value),
      dateDialog: false,
      timeModel: this.filterTime(this.value),
      timeDialog: false
    };
  },


  computed: {
    pickerValue: {
      get: function get() {
        return this.dateModel;
      },
      set: function set(value) {
        this.dateModel = value;
        this.dateDialog = false;
        this.updateDateTime();
      }
    },

    timePickerValue: {
      get: function get() {
        return this.timeModel;
      },
      set: function set(value) {
        this.timeModel = value;
        this.timeDialog = false;
        this.updateDateTime();
      }
    }
  },

  created: function created() {
    this.updateDateTime();
  },


  methods: {
    filterDate: function filterDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD');
    },
    filterTime: function filterTime(time) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).format('hh:mm');
    },
    updateDateTime: function updateDateTime() {
      this.$emit('input', __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.pickerValue + ' ' + this.timePickerValue).format('YYYY-MM-DD hh:mm:ss'));
    }
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'label', 'item-value', 'apiEndpoint', 'error', 'error-messages'],

  data: function data() {
    return {
      dialog: false,
      product: '',
      search: '',
      loading: false,
      pagination: {},
      rowsPerPageItems: [5, 10, 25, 50, { 'text': 'Tot', 'value': -1 }],
      totalItems: 0,
      timeoutId: null,
      processing: false,
      selected: [],
      firstLoad: false
    };
  },

  watch: {
    pagination: {
      handler: function handler(newValue, oldValue) {
        if (newValue.page === oldValue.page && this.search && newValue.rowsPerPage === oldValue.rowsPerPage) {
          return;
        }
        this.loadItems();
      },

      deep: true
    },

    search: function search(value) {
      var _this = this;

      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(function () {
        if (_this.firstLoad) {
          _this.firstLoad = false;
          if (!value) {
            _this.$emit('input', null);
          }
          return;
        }

        if (_this.dialog === false && value) {
          _this.dialog = true;
        }

        if (!_this.dialog && !value) {
          _this.$emit('input', null);
          return;
        }
        if (_this.pagination.page === 1) {
          _this.loadItems();
        } else {
          _this.pagination.page = 1;
          _this.loadItems();
        }
      }, 500);
    },
    selected: function selected(value) {
      if (value.length > 1) {
        value.splice(0, 1);
      }
    },
    dialog: function dialog(value) {
      var _this2 = this;

      this.$store.commit(this.apiEndpoint + '/' + this.apiEndpoint.toUpperCase(), []);
      if (value) {
        this.$nextTick(function () {
          _this2.$refs.productSearch.focus();
        });
      }
    },
    value: function value(_value) {
      if (_value === null) {
        this.search = '';
      }
    }
  },

  computed: {
    items: function items() {
      return this.apiEndpoint === 'stock' ? this.$store.state[this.apiEndpoint].data.filter(function (f) {
        return f.qty > 0;
      }) : this.$store.state[this.apiEndpoint].data;
    },
    hasPagination: function hasPagination() {
      return this.totalItems > 5;
    },
    headers: function headers() {
      var _this3 = this;

      var headers = [{
        text: 'Cod',
        align: 'left',
        sortable: false,
        value: '' + (this.apiEndpoint === 'stock' ? 'product_id' : 'cod'),
        nestedValue: this.apiEndpoint === 'stock' ? 'product.cod' : null
      }, {
        text: 'Denumire',
        align: 'left',
        sortable: false,
        value: '' + (this.apiEndpoint === 'stock' ? 'product_id' : 'name'),
        nestedValue: this.apiEndpoint === 'stock' ? 'product.name' : null
      }, {
        text: '' + (this.apiEndpoint === 'stock' ? 'Cantitate' : 'Cod furnizor'),
        align: 'left',
        sortable: false,
        value: this.apiEndpoint === 'stock' ? 'qty' : 'cod_furnizor',
        format: function format(item) {
          if (_this3.apiEndpoint === 'stock') {
            return Math.round(Number(item.qty) * 100) / 100;
          }
          return item.cod_furnizor;
        }
      }];

      if (this.apiEndpoint === 'stock') {
        headers.push({
          text: 'Stare',
          align: 'left',
          sortable: false,
          value: 'status',
          format: function format(item) {
            return _this3.$store.getters['stock/status'](item.status).name;
          }
        });
      }

      return headers;
    }
  },

  methods: {
    loadItems: function loadItems(id) {
      var _this4 = this;

      this.loading = true;
      if (id) {
        this.$store.dispatch(this.apiEndpoint + '/LOAD_ONE', id).then(function (result) {
          _this4.loading = false;
          _this4.search = result ? result.data.name ? result.data.name : result.data.product.name : '';
        });
      } else {
        var filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          search: this.search
        }, this.pagination);

        if (this.apiEndpoint === 'stock') {
          filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, filter, { employee_id: this.$store.state.user.id });
        }
        this.$store.dispatch(this.apiEndpoint + '/LOAD', { filter: filter }).then(function (result) {
          _this4.totalItems = result.meta.total;
          _this4.selected = _this4.items.length ? _this4.items.slice(0, 1) : [];
          _this4.loading = false;
        });
      }
    },
    onProductSelect: function onProductSelect() {
      var selected = this.selected.length ? this.selected[0] : null;
      if (this.itemValue) {
        this.$emit('input', selected[this.itemValue]);
      } else {
        this.$emit('input', selected);
      }
      this.search = selected ? this.apiEndpoint === 'stock' ? selected.product.name : selected.name : this.search;
      this.firstLoad = true;
      this.dialog = false;
    },
    displayRowData: function displayRowData(props, header) {
      if (props.item[header.value] || props.item[header.value] === 0) {
        if (header.nestedValue) {
          var nestedValues = header.nestedValue.split('.');
          var rowData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.item);
          nestedValues.forEach(function (prop) {
            rowData = rowData[prop];
          });
          return rowData;
        } else if (header.format) {
          return header.format(props.item);
        } else {
          return props.item[header.value];
        }
      }
      return '';
    }
  },

  created: function created() {
    var _this5 = this;

    this.$nextTick(function () {
      _this5.$refs.product.focus();
    });
    if (this.value) {
      this.loadItems(this.value);
      this.firstLoad = true;
    }
    this.pagination.rowsPerPage = 5;
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








window.Vue = __webpack_require__(2);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuetify___default.a);

Object(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('loader', __webpack_require__(329).default);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ConfirmationDialog', __webpack_require__(331).default);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ToastMessage', __webpack_require__(333).default);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('DataTable', __webpack_require__(39).default);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('EditDialog', __webpack_require__(335).default);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsView_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39c9b7a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsView_vue__ = __webpack_require__(263);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39c9b7a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"view-container",attrs:{"fluid":"","grid-list-lg":"","data-watch":_vm.watchLoader}},[(!_vm.isLoaded)?_c('v-layout',{attrs:{"justify-center":"","align-center":"","fill-height":""}},[_c('loader')],1):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('v-alert',{attrs:{"type":"error","value":true}},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"headline mb-3"},[_vm._v("My Account")]),_vm._v(" "),_c('v-card',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"browse-card-media"},[_c('v-card-media',{attrs:{"src":((_vm.$store.state.user.photo) + "?s=100"),"height":"100px","contain":""}})],1),_vm._v(" "),_c('v-flex',[_c('div',[_c('div',{staticClass:"headline pt-2"},[_vm._v(_vm._s(_vm.$store.state.user.name))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$store.state.user.email))])]),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-0"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.onLogout}},[_vm._v("Logout")])],1)],1)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitsView_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b3acade_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisitsView_vue__ = __webpack_require__(291);
function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b3acade_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisitsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitCard_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0a3e22c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisitCard_vue__ = __webpack_require__(277);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0a3e22c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisitCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 275 */,
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 66,
	"./af.js": 66,
	"./ar": 67,
	"./ar-dz": 68,
	"./ar-dz.js": 68,
	"./ar-kw": 69,
	"./ar-kw.js": 69,
	"./ar-ly": 70,
	"./ar-ly.js": 70,
	"./ar-ma": 71,
	"./ar-ma.js": 71,
	"./ar-sa": 72,
	"./ar-sa.js": 72,
	"./ar-tn": 73,
	"./ar-tn.js": 73,
	"./ar.js": 67,
	"./az": 74,
	"./az.js": 74,
	"./be": 75,
	"./be.js": 75,
	"./bg": 76,
	"./bg.js": 76,
	"./bm": 77,
	"./bm.js": 77,
	"./bn": 78,
	"./bn.js": 78,
	"./bo": 79,
	"./bo.js": 79,
	"./br": 80,
	"./br.js": 80,
	"./bs": 81,
	"./bs.js": 81,
	"./ca": 82,
	"./ca.js": 82,
	"./cs": 83,
	"./cs.js": 83,
	"./cv": 84,
	"./cv.js": 84,
	"./cy": 85,
	"./cy.js": 85,
	"./da": 86,
	"./da.js": 86,
	"./de": 87,
	"./de-at": 88,
	"./de-at.js": 88,
	"./de-ch": 89,
	"./de-ch.js": 89,
	"./de.js": 87,
	"./dv": 90,
	"./dv.js": 90,
	"./el": 91,
	"./el.js": 91,
	"./en-au": 92,
	"./en-au.js": 92,
	"./en-ca": 93,
	"./en-ca.js": 93,
	"./en-gb": 94,
	"./en-gb.js": 94,
	"./en-ie": 95,
	"./en-ie.js": 95,
	"./en-il": 96,
	"./en-il.js": 96,
	"./en-nz": 97,
	"./en-nz.js": 97,
	"./eo": 98,
	"./eo.js": 98,
	"./es": 99,
	"./es-do": 100,
	"./es-do.js": 100,
	"./es-us": 101,
	"./es-us.js": 101,
	"./es.js": 99,
	"./et": 102,
	"./et.js": 102,
	"./eu": 103,
	"./eu.js": 103,
	"./fa": 104,
	"./fa.js": 104,
	"./fi": 105,
	"./fi.js": 105,
	"./fo": 106,
	"./fo.js": 106,
	"./fr": 107,
	"./fr-ca": 108,
	"./fr-ca.js": 108,
	"./fr-ch": 109,
	"./fr-ch.js": 109,
	"./fr.js": 107,
	"./fy": 110,
	"./fy.js": 110,
	"./gd": 111,
	"./gd.js": 111,
	"./gl": 112,
	"./gl.js": 112,
	"./gom-latn": 113,
	"./gom-latn.js": 113,
	"./gu": 114,
	"./gu.js": 114,
	"./he": 115,
	"./he.js": 115,
	"./hi": 116,
	"./hi.js": 116,
	"./hr": 117,
	"./hr.js": 117,
	"./hu": 118,
	"./hu.js": 118,
	"./hy-am": 119,
	"./hy-am.js": 119,
	"./id": 120,
	"./id.js": 120,
	"./is": 121,
	"./is.js": 121,
	"./it": 122,
	"./it.js": 122,
	"./ja": 123,
	"./ja.js": 123,
	"./jv": 124,
	"./jv.js": 124,
	"./ka": 125,
	"./ka.js": 125,
	"./kk": 126,
	"./kk.js": 126,
	"./km": 127,
	"./km.js": 127,
	"./kn": 128,
	"./kn.js": 128,
	"./ko": 129,
	"./ko.js": 129,
	"./ky": 130,
	"./ky.js": 130,
	"./lb": 131,
	"./lb.js": 131,
	"./lo": 132,
	"./lo.js": 132,
	"./lt": 133,
	"./lt.js": 133,
	"./lv": 134,
	"./lv.js": 134,
	"./me": 135,
	"./me.js": 135,
	"./mi": 136,
	"./mi.js": 136,
	"./mk": 137,
	"./mk.js": 137,
	"./ml": 138,
	"./ml.js": 138,
	"./mn": 139,
	"./mn.js": 139,
	"./mr": 140,
	"./mr.js": 140,
	"./ms": 141,
	"./ms-my": 142,
	"./ms-my.js": 142,
	"./ms.js": 141,
	"./mt": 143,
	"./mt.js": 143,
	"./my": 144,
	"./my.js": 144,
	"./nb": 145,
	"./nb.js": 145,
	"./ne": 146,
	"./ne.js": 146,
	"./nl": 147,
	"./nl-be": 148,
	"./nl-be.js": 148,
	"./nl.js": 147,
	"./nn": 149,
	"./nn.js": 149,
	"./pa-in": 150,
	"./pa-in.js": 150,
	"./pl": 151,
	"./pl.js": 151,
	"./pt": 152,
	"./pt-br": 153,
	"./pt-br.js": 153,
	"./pt.js": 152,
	"./ro": 154,
	"./ro.js": 154,
	"./ru": 155,
	"./ru.js": 155,
	"./sd": 156,
	"./sd.js": 156,
	"./se": 157,
	"./se.js": 157,
	"./si": 158,
	"./si.js": 158,
	"./sk": 159,
	"./sk.js": 159,
	"./sl": 160,
	"./sl.js": 160,
	"./sq": 161,
	"./sq.js": 161,
	"./sr": 162,
	"./sr-cyrl": 163,
	"./sr-cyrl.js": 163,
	"./sr.js": 162,
	"./ss": 164,
	"./ss.js": 164,
	"./sv": 165,
	"./sv.js": 165,
	"./sw": 166,
	"./sw.js": 166,
	"./ta": 167,
	"./ta.js": 167,
	"./te": 168,
	"./te.js": 168,
	"./tet": 169,
	"./tet.js": 169,
	"./tg": 170,
	"./tg.js": 170,
	"./th": 171,
	"./th.js": 171,
	"./tl-ph": 172,
	"./tl-ph.js": 172,
	"./tlh": 173,
	"./tlh.js": 173,
	"./tr": 174,
	"./tr.js": 174,
	"./tzl": 175,
	"./tzl.js": 175,
	"./tzm": 176,
	"./tzm-latn": 177,
	"./tzm-latn.js": 177,
	"./tzm.js": 176,
	"./ug-cn": 178,
	"./ug-cn.js": 178,
	"./uk": 179,
	"./uk.js": 179,
	"./ur": 180,
	"./ur.js": 180,
	"./uz": 181,
	"./uz-latn": 182,
	"./uz-latn.js": 182,
	"./uz.js": 181,
	"./vi": 183,
	"./vi.js": 183,
	"./x-pseudo": 184,
	"./x-pseudo.js": 184,
	"./yo": 185,
	"./yo.js": 185,
	"./zh-cn": 186,
	"./zh-cn.js": 186,
	"./zh-hk": 187,
	"./zh-hk.js": 187,
	"./zh-tw": 188,
	"./zh-tw.js": 188
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 276;

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',{staticClass:"title"},[_vm._v("Client: "+_vm._s(_vm.visit.machine.client_location.client.name))])]),_vm._v(" "),(_vm.visit.machine.client_location)?_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',{staticClass:"subheading"},[_c('b',[_vm._v("Locatie client:")]),_vm._v(" "+_vm._s(_vm.visit.machine.client_location.name))])]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',[_c('b',[_vm._v("Data:")]),_vm._v(" "+_vm._s(_vm.filterDate(_vm.visit.created_at)))])]),_vm._v(" "),_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',[_c('b',[_vm._v("Stare:")]),_vm._v(" "+_vm._s(this.$store.getters['visits/status'](_vm.visit.status).name))])]),_vm._v(" "),_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',[_c('strong',[_vm._v("Aparat:")]),_vm._v(" "+_vm._s(_vm.visit.machine ? ((_vm.visit.machine.idstr) + " (" + (_vm.visit.machine.model.name) + ")") : ''))])]),_vm._v(" "),_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',[_c('b',[_vm._v("Număr acțiuni:")]),_vm._v(" "+_vm._s(_vm.visit.total_actions))])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionTree_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fdf8044_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionTree_vue__ = __webpack_require__(286);
function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fdf8044_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tree_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43cc8d37_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_vue__ = __webpack_require__(285);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43cc8d37_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeNode_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb324d00_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TreeNode_vue__ = __webpack_require__(284);
function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb324d00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeNode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb324d00_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TreeNode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"node",class:{ expanded: _vm.expanded , selected:this.$store.state.actions.selectedItem && _vm.node.id === this.$store.state.actions.selectedItem.id }},[(_vm.hasChildren)?_c('div',{staticClass:"group text",on:{"click":_vm.onSelect,"dblclick":_vm.onEdit}},[_c('v-icon',[_vm._v(_vm._s(_vm.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))]),_vm._v("\n        "+_vm._s(_vm.node.name)+"\n    ")],1):_c('div',{staticClass:"text noChildren",on:{"click":_vm.onSelect,"dblclick":_vm.onEdit}},[_vm._v(_vm._s(_vm.node.name))]),_vm._v(" "),_vm._l((_vm.node.children),function(node,index){return (_vm.hasChildren)?_c('tree-node',{directives:[{name:"show",rawName:"v-show",value:(_vm.expanded),expression:"expanded"}],key:index,attrs:{"mode":_vm.mode,"node":node}}):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree"},_vm._l((_vm.data),function(node,index){return _c('tree-node',{key:index,attrs:{"node":node,"mode":_vm.mode}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm4":"","xs12":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Caută","single-line":"","hide-details":""},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1),_vm._v(" "),(_vm.mode === 'edit')?_c('v-flex',{attrs:{"sm8":"","xs12":""}},[_c('v-layout',{attrs:{"right":"","wrap":""}},[(_vm.selectedItem)?_c('section',[_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.onAction('edit')}}},[_vm._v("Editează")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.onAction('delete')}}},[_vm._v("Șterge")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.onAction('add')}}},[_vm._v("Adaugă")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"fixed-header"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('tree',{attrs:{"data":_vm.data,"mode":_vm.mode}})],1),_vm._v(" "),(_vm.data.length === 0)?_c('v-flex',[_c('p',[_vm._v("Nu sunt acțiuni disponibile")])]):_vm._e()],1)],1),_vm._v(" "),_c('toast-message'),_vm._v(" "),_c('confirmation-dialog')],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-card',[_c('v-card-title',[_vm._v("\n              "+_vm._s(_vm.isAddMode ? 'Adaugă' : 'Editează')+" acțiune\n            ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"single-line":"","hide-details":""},model:{value:(_vm.editDialogData.name),callback:function ($$v) {_vm.$set(_vm.editDialogData, "name", $$v)},expression:"editDialogData.name"}})],1),_vm._v(" "),(_vm.errorMessageGeneric)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"type":"error"}},[_vm._v(_vm._s(_vm.errorMessageGeneric))])],1):_vm._e(),_vm._v(" "),(_vm.errorMessages.length)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"type":"error"}},[_vm._v(_vm._s(_vm.errorMessages))])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.editDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","loading":_vm.processing,"disabled":_vm.processing},nativeOn:{"click":function($event){_vm.onDialogSave()}}},[_vm._v("\n                    Save\n                ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","data-watch":_vm.selectedItem}},[_c('v-flex',{attrs:{"xs12":"","sm9":""}},[_c('v-text-field',{ref:"action",staticClass:"input-group--focused",attrs:{"label":"Acțiune","disabled":"","value":_vm.path,"errors":_vm.errors,"error":_vm.error,"error-messages":_vm.errorMessages}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-dialog',{attrs:{"close-on-content-click":false,"width":!_vm.isMobile ? '60%' : '',"persistent":!_vm.isMobile,"fullscreen":_vm.isMobile,"hide-overlay":_vm.isMobile,"transition":_vm.isMobile ? 'dialog-bottom-transition':''},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-btn',{attrs:{"slot":"activator","outline":""},slot:"activator"},[_vm._v("Selectează")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-toolbar',{attrs:{"dark":"","color":"pink"}},[_c('v-toolbar-title',[_vm._v("Acțiuni")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.editDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('action-tree',{attrs:{"data":_vm.$store.getters['actions/tree'],"mode":"select"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 288 */,
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"error":_vm.error,"error-messages":_vm.errors,"loading":!_vm.isLoaded,"items":_vm.listItems,"search-input":_vm.search,"hide-no-data":"","hide-selected":"","item-text":_vm.itemText,"item-value":_vm.itemValue,"label":_vm.label,"required":_vm.required,"return-object":_vm.returnObject},on:{"update:searchInput":function($event){_vm.search=$event}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 290 */,
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-xs":"","data-watch-loader":_vm.watchLoader}},[(!_vm.isLoaded)?_c('v-layout',{attrs:{"justify-center":"","align-center":"","fill-height":""}},[_c('loader')],1):_c('v-layout',{staticClass:"height-100-vh",attrs:{"row":"","wrap":""}},[(_vm.agency || _vm.employee || _vm.createdBy || _vm.machine || _vm.client || _vm.startDate || _vm.endDate || _vm.status !== null || _vm.action !== null)?_c('v-flex',{attrs:{"xs12":"","pb-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[(_vm.agency)?_c('v-chip',{attrs:{"close":""},model:{value:(_vm.agencyChip),callback:function ($$v) {_vm.agencyChip=$$v},expression:"agencyChip"}},[_vm._v("Sucursală: "+_vm._s(_vm.agency.name))]):_vm._e(),_vm._v(" "),(_vm.employee)?_c('v-chip',{attrs:{"close":""},model:{value:(_vm.employeeChip),callback:function ($$v) {_vm.employeeChip=$$v},expression:"employeeChip"}},[_vm._v("Angajat: "+_vm._s(_vm.employee.name))]):_vm._e(),_vm._v(" "),(_vm.createdBy)?_c('v-chip',{attrs:{"close":""},model:{value:(_vm.createdByChip),callback:function ($$v) {_vm.createdByChip=$$v},expression:"createdByChip"}},[_vm._v("Înregistrată de: "+_vm._s(_vm.createdBy.name))]):_vm._e(),_vm._v(" "),(_vm.machine)?_c('v-chip',{attrs:{"close":""},model:{value:(_vm.machineChip),callback:function ($$v) {_vm.machineChip=$$v},expression:"machineChip"}},[_vm._v("Aparat: "+_vm._s(_vm.machine.idstr))]):_vm._e(),_vm._v(" "),(_vm.client)?_c('v-chip',{attrs:{"close":""},model:{value:(_vm.clientChip),callback:function ($$v) {_vm.clientChip=$$v},expression:"clientChip"}},[_vm._v("Client: "+_vm._s(_vm.client.name))]):_vm._e(),_vm._v(" "),(_vm.status !== null)?_c('v-chip',{attrs:{"close":""},model:{value:(_vm.statusChip),callback:function ($$v) {_vm.statusChip=$$v},expression:"statusChip"}},[_vm._v("Stare: "+_vm._s(_vm.status.name))]):_vm._e(),_vm._v(" "),(_vm.action !== null)?_c('v-chip',{attrs:{"close":""},model:{value:(_vm.actionChip),callback:function ($$v) {_vm.actionChip=$$v},expression:"actionChip"}},[_vm._v("Acțiune: "+_vm._s(_vm.getActionName(_vm.action)))]):_vm._e(),_vm._v(" "),(_vm.startDate)?_c('v-chip',{attrs:{"close":""},model:{value:(_vm.startDateChip),callback:function ($$v) {_vm.startDateChip=$$v},expression:"startDateChip"}},[_vm._v("Dată început: "+_vm._s(_vm.startDate))]):_vm._e(),_vm._v(" "),(_vm.endDate)?_c('v-chip',{attrs:{"close":""},model:{value:(_vm.endDateChip),callback:function ($$v) {_vm.endDateChip=$$v},expression:"endDateChip"}},[_vm._v("Dată sfârșit: "+_vm._s(_vm.endDate))]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('pull-to',{attrs:{"top-load-method":_vm.refresh,"top-config":_vm.pullDownConfig}},[_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},_vm._l((_vm.$store.state.visits.tabItems),function(tabItem){return _c('v-tab-item',{key:tabItem.id},[_vm._l((_vm.getTabItems(tabItem.id)),function(item,index){return _c('v-flex',{key:index,attrs:{"xs12":""},on:{"click":function($event){_vm.goToVisit(item)}}},[_c('visit-card',{attrs:{"visit":item}})],1)}),_vm._v(" "),(_vm.items.length === 0 || _vm.getTabItems(tabItem.id).length === 0)?_c('v-flex',[_c('p',{staticClass:"headline text-xs-center"},[_vm._v("Nu a fost găsită nici o vizită "+_vm._s(("" + (tabItem.id ? 'efectuată' : 'programată'))))])]):_vm._e(),_vm._v(" "),(_vm.items.length)?_c('v-flex',{attrs:{"xs12":""}},[_c('infinite-loading',{ref:"infiniteLoading",refInFor:true,attrs:{"distance":200},on:{"infinite":_vm.infiniteHandler}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('loader')],1),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"},[_c('p',[_vm._v("~")])])])],1):_vm._e()],2)}))],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","bottom":"","right":"","color":"pink","dark":"","fixed":""},on:{"click":function($event){$event.stopPropagation();_vm.addVisit()}}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),(_vm.dialogData)?_c('edit-dialog',{attrs:{"entityName":"Vizită","fields":_vm.fields,"isMobile":true,"fieldValues":_vm.dialogData,"apiEndpoint":_vm.apiEndpoint},on:{"status":_vm.onStatusChange}}):_vm._e()],1),_vm._v(" "),(_vm.dialog)?_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('v-toolbar',{attrs:{"dark":"","color":"pink","card":"","fixed":""}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Filtrare")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":"","loading":!_vm.isLoaded,"disabled":!_vm.isLoaded},nativeOn:{"click":function($event){_vm.filterVisits()}}},[_vm._v("Filtrează")])],1)],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-start":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm3":""}},[_c('v-subheader',[_vm._v("Sucursală")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm7":""}},[_c('v-select',{attrs:{"items":_vm.$store.state.agencies.data,"item-text":"name","label":"Select","single-line":"","return-object":""},model:{value:(_vm.agencyDialog),callback:function ($$v) {_vm.agencyDialog=$$v},expression:"agencyDialog"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-start":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm3":""}},[_c('v-subheader',[_vm._v("Angajat")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm7":""}},[_c('v-select',{attrs:{"items":_vm.$store.state.employees.data,"label":"Select","single-line":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                                          "+_vm._s(("" + (data.item.name)))+"\n                                        ")]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(("" + (data.item.name)))}})]]}}]),model:{value:(_vm.employeeDialog),callback:function ($$v) {_vm.employeeDialog=$$v},expression:"employeeDialog"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-start":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm3":""}},[_c('v-subheader',[_vm._v("Înregistrată de")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm7":""}},[_c('v-select',{attrs:{"items":_vm.$store.state.employees.data,"item-text":"name","label":"Select","single-line":"","return-object":""},model:{value:(_vm.createdByDialog),callback:function ($$v) {_vm.createdByDialog=$$v},expression:"createdByDialog"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-start":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm3":""}},[_c('v-subheader',[_vm._v("Aparat")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm7":""}},[_c('autocomplete-selector',{attrs:{"items":_vm.$store.state.machines.data,"item-text":"idstr","item-value":"id","label":"Select","return-object":true,"apiEndpoint":"machines"},model:{value:(_vm.machineDialog),callback:function ($$v) {_vm.machineDialog=$$v},expression:"machineDialog"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-start":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm3":""}},[_c('v-subheader',[_vm._v("Client")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","sm7":""}},[_c('autocomplete-selector',{attrs:{"items":_vm.$store.state.clients.data,"item-text":"name","item-value":"id","label":"Select","return-object":true,"apiEndpoint":"clients"},model:{value:(_vm.clientDialog),callback:function ($$v) {_vm.clientDialog=$$v},expression:"clientDialog"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-start":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-subheader',{model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_vm._v("Acțiune")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm7":""}},[_c('action-selector',{model:{value:(_vm.actionDialog),callback:function ($$v) {_vm.actionDialog=$$v},expression:"actionDialog"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-start":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-subheader',[_vm._v("Perioada")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm7":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-menu',{ref:"startDateDialog",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.startDate,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.startDate=$event}},model:{value:(_vm.startDateModal),callback:function ($$v) {_vm.startDateModal=$$v},expression:"startDateModal"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Dată început","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.startDateDialog),callback:function ($$v) {_vm.startDateDialog=$$v},expression:"startDateDialog"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"max":_vm.endDate},on:{"input":function($event){_vm.$refs.startDateDialog.save(_vm.startDate)}},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-menu',{ref:"endDateDialog",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.endDate,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.endDate=$event}},model:{value:(_vm.endDateModal),callback:function ($$v) {_vm.endDateModal=$$v},expression:"endDateModal"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Dată sfârșit","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.endDateDialog),callback:function ($$v) {_vm.endDateDialog=$$v},expression:"endDateDialog"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"min":_vm.startDate},on:{"input":function($event){_vm.$refs.endDateDialog.save(_vm.endDate)}},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitView_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_baf72146_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisitView_vue__ = __webpack_require__(293);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_baf72146_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisitView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-xs":"","data-watch-loader":_vm.watchLoader}},[(!_vm.isLoaded)?_c('v-layout',{attrs:{"justify-center":"","align-center":"","fill-height":""}},[_c('loader')],1):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',{staticClass:"title"},[_vm._v("Client: "+_vm._s(_vm.$store.getters['clientsLocations/clientLocation'](_vm.visit.client_location_id).client.name))])]),_vm._v(" "),(_vm.visit.machine.client_location)?_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',{staticClass:"subheading"},[_c('b',[_vm._v("Locatie client:")]),_vm._v(" "+_vm._s(_vm.$store.getters['clientsLocations/clientLocation'](_vm.visit.client_location_id).name))])]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',[_c('b',[_vm._v("Data:")]),_vm._v(" "+_vm._s(_vm.filterDate(_vm.visit.updated_at)))])]),_vm._v(" "),_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',[_c('b',[_vm._v("Status:")]),_vm._v(" "+_vm._s(this.$store.getters['visits/status'](_vm.visit.status).name))])]),_vm._v(" "),_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',[_c('b',[_vm._v("Aparat:")]),_vm._v(" "+_vm._s(_vm.visit.machine ? ((_vm.visit.machine.idstr) + " (" + (_vm.visit.machine.model.name) + ")") : ''))])]),_vm._v(" "),_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',[_c('b',[_vm._v("Angajat:")]),_vm._v(" "+_vm._s(_vm.visit.employee ? _vm.visit.employee.name : ''))])]),_vm._v(" "),_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',[_c('strong',[_vm._v("Înregistrată de:")]),_vm._v(" "+_vm._s(_vm.visit.created_by ? _vm.visit.created_by.name : ''))])]),_vm._v(" "),(_vm.visit.agency)?_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',[_c('b',[_vm._v("Sucursala:")]),_vm._v(" "+_vm._s(_vm.visit.agency.name))])]):_vm._e(),_vm._v(" "),(_vm.visit.machine.client_location)?_c('v-flex',{attrs:{"lg6":"","md6":"","xs12":""}},[_c('p',[_c('b',[_vm._v("Contor general:")]),_vm._v(" "+_vm._s(_vm.visit.counter))])]):_vm._e()],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isLoaded && _vm.visit.notes)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("\n                    Note\n                ")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.visit.notes))])])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('v-layout',{attrs:{"row":"","wrap":"","mt-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.visitActions.length)?_c('data-table',{attrs:{"actions":_vm.actions,"items":_vm.visitActions,"headers":_vm.headers,"entityName":_vm.entityName},on:{"action":_vm.onRowAction}}):_c('v-btn',{attrs:{"block":"","color":"primary","dark":""},on:{"click":function($event){_vm.onActionAdd()}}},[_vm._v("Adaugă acțiune")])],1)],1):_vm._e(),_vm._v(" "),(_vm.isLoaded && _vm.visit.status === 0 && _vm.visitActions.length)?_c('v-layout',{attrs:{"row":"","wrap":"","mt-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"loading":_vm.processing,"block":"","color":"success","dark":""},on:{"click":function($event){_vm.closeVisit()}}},[_vm._v("Închide vizita")])],1)],1):_vm._e(),_vm._v(" "),_c('toast-message'),_vm._v(" "),(_vm.dialogData)?_c('edit-dialog',{attrs:{"entityName":_vm.entityName,"fields":_vm.fields,"isMobile":true,"fieldValues":_vm.dialogData,"apiEndpoint":"visitActions"},on:{"status":_vm.onStatusChange}}):_vm._e(),_vm._v(" "),(_vm.dialogDataVisit)?_c('edit-dialog',{attrs:{"entityName":"Vizită","fields":_vm.fieldsVisit,"isMobile":true,"fieldValues":_vm.dialogDataVisit,"apiEndpoint":"visits"},on:{"status":_vm.onStatusChangeVisit}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginView_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d78cadac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginView_vue__ = __webpack_require__(296);
function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d78cadac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"display-3",attrs:{"mb-5":"","justify-center":""}},[_vm._v("TEK")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-form',[_c('v-text-field',{attrs:{"prepend-icon":"person","name":"login","label":"Email","type":"text","error":!!_vm.errorMessages.length && 'email' in _vm.errorMessages,"error-messages":_vm.dialogErrorMessage('email'),"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","name":"password","label":"Parolă","id":"password","type":"password","error":!!_vm.errorMessages.length && 'password' in _vm.errorMessages,"error-messages":_vm.dialogErrorMessage('password'),"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),(_vm.errorMessageGeneric)?_c('v-alert',{attrs:{"value":true,"type":"error"}},[_vm._v(_vm._s(_vm.errorMessageGeneric))]):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"block":"","color":"primary"},on:{"click":function($event){_vm.login()}}},[_vm._v("Login")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MachinesReportsView_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45707d00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MachinesReportsView_vue__ = __webpack_require__(300);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MachinesReportsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45707d00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MachinesReportsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalItems > 0 || !_vm.apiEndpoint),expression:"totalItems > 0 || !apiEndpoint"}]},[_c('v-layout',{attrs:{"row":"","wrap":"","pl-3":"","pr-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.filter)?_vm._t("filterTrigger"):_c('v-text-field',{attrs:{"append-icon":"search","label":"Caută","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],2)],1),_vm._v(" "),_vm._t("filter"),_vm._v(" "),_c('v-data-table',{ref:"table",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"pagination":_vm.pagination,"total-items":_vm.totalItems,"loading":_vm.loading,"rows-per-page-items":_vm.rowsPerPageItems,"rows-per-page-text":"Rezultate pe pagină","disable-initial-sort":"","item-key":"id","hide-actions":!_vm.hasPagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{on:{"click":function($event){_vm.tableToggleRowExpand(props)}}},_vm._l((_vm.headers),function(header,index){return _c('td',{key:index,staticClass:"line-height-2",domProps:{"innerHTML":_vm._s(_vm.displayRowData(props, header))}})}))]}},{key:"expand",fn:function(props){return [_c('v-card',{staticClass:"card-expanded",attrs:{"flat":""}},[_vm._l((_vm.actions),function(action,index){return _c('v-btn',{key:index,attrs:{"color":action.color,"flat":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.onAction(action.event, props.item)}}},[_vm._v(_vm._s(action.name))])})],2)]}}])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":"","data-watch-loader":_vm.watchLoader}},[(_vm.loading && _vm.$route.params.machineId)?_c('v-layout',{attrs:{"justify-center":"","align-center":"","fill-height":""}},[_c('loader')],1):_c('v-layout',{attrs:{"row":"","justify-start":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm7":""}},[_c('autocomplete-selector',{attrs:{"items":_vm.$store.state.machines.data,"item-text":"idstr","item-value":"id","label":"Caută aparat","return-object":true,"apiEndpoint":"machines"},model:{value:(_vm.machine),callback:function ($$v) {_vm.machine=$$v},expression:"machine"}})],1)],1),_vm._v(" "),(_vm.machine && _vm.hasItems)?_c('data-table',{attrs:{"actions":_vm.actions,"items":_vm.items,"headers":_vm.headers,"entityName":"Istoric","apiEndpoint":"visitActions","staticData":true,"filter":_vm.filter,"mode":"select"},on:{"action":_vm.onRowAction,"staticItems":_vm.staticItems,"loading":_vm.onLoading}}):_vm._e(),_vm._v(" "),(!_vm.hasItems)?_c('v-flex',[_c('p',{staticClass:"headline text-xs-center"},[_vm._v("Nu a fost găsită nici o acțiune "+_vm._s(_vm.machine ? ("pentru aparatul " + (_vm.machine.idstr)) : ''))])]):_vm._e(),_vm._v(" "),_c('toast-message'),_vm._v(" "),_c('confirmation-dialog')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportActionsView_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4688919a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportActionsView_vue__ = __webpack_require__(302);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportActionsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4688919a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportActionsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":"","data-watch-loader":_vm.watchLoader}},[(!_vm.isLoaded)?_c('v-layout',{attrs:{"justify-center":"","align-center":"","fill-height":""}},[_c('loader')],1):_vm._e(),_vm._v(" "),(_vm.isLoaded && _vm.items.length === 0)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('p',{staticClass:"headline text-xs-center"},[_vm._v("Nu a fost găsită nici o acțiune de făcut")])])],1):_vm._e(),_vm._v(" "),(_vm.filter.status === 0)?_c('data-table',{attrs:{"actions":_vm.actions,"items":_vm.items,"headers":_vm.headers,"apiEndpoint":"visitActions","staticData":true,"filter":_vm.filter,"mode":"select"},on:{"action":_vm.onRowAction,"staticItems":_vm.staticItems}}):_vm._e(),_vm._v(" "),_c('toast-message'),_vm._v(" "),_c('confirmation-dialog')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoInternetConnectionView_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3baa59d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoInternetConnectionView_vue__ = __webpack_require__(304);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoInternetConnectionView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3baa59d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoInternetConnectionView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":"","align-center":"","fill-height":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"text-xs-center headline"},[_vm._v("Din păcate nu ai o conexiune bună la internet")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"color":"pink"},on:{"click":function($event){_vm.retry()}}},[_vm._v("Reîncarcă")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    data: [],
    status: [{ id: 0, name: 'Programată', icon: 'schedule', color: 'red' }, { id: 1, name: 'Efectuată', icon: 'check_box', color: 'green' }],
    dialog: null,
    filter: null,
    tab: null,
    tabItems: [{ id: 0, text: 'Programate' }, { id: 1, text: 'Efectuate' }]
  },

  actions: {
    LOAD: function LOAD(_ref, _ref2) {
      var commit = _ref.commit,
          rootGetters = _ref.rootGetters,
          state = _ref.state;
      var id = _ref2.id,
          filter = _ref2.filter,
          loadMore = _ref2.loadMore;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var params = {};
        if (filter) {
          for (var key in filter) {
            if (filter.hasOwnProperty(key) && filter[key] !== null) {
              params[key] = filter[key];
            }
          }
          if (filter.sortBy) {
            params.order_by = filter.sortBy + ':' + (filter.descending ? 'DESC' : 'ASC');
          }

          delete params.sortBy;
          delete params.descending;
          delete params.totalItems;
        }
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/visits' + (id ? '/' + id : ''), { params: params }).then(function (response) {
          return response.data;
        }).then(function (response) {
          if (id) {
            response.data.actions = response.data.actions.map(function (item) {
              item.path = rootGetters['actions/action'](item.action.id).path;
              return item;
            });
          }
          commit('visitActions/VISIT_ACTIONS', id ? response.data.actions : null, { root: true });
          if (response.meta) {
            if (loadMore) {
              commit('APPEND', response.data);
            } else {
              commit('VISITS', id ? [response.data] : response.data);
            }
          } else {
            commit('VISITS', id ? [response.data] : response.data);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    DELETE: function DELETE(_ref3, id) {
      var commit = _ref3.commit,
          state = _ref3.state;

      commit('DELETE', id);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/visits/' + id).then(function (response) {
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    EDIT: function EDIT(_ref4, data) {
      var commit = _ref4.commit,
          rootState = _ref4.rootState;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/visits/' + data.id, data).then(function (response) {
          return response.data;
        }).then(function (response) {
          commit('EDIT', response.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    ADD: function ADD(_ref5, data) {
      var commit = _ref5.commit,
          rootState = _ref5.rootState;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/visits', data).then(function (response) {
          return response.data;
        }).then(function (response) {
          commit('ADD', response.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },

  mutations: {
    VISITS: function VISITS(state, payload) {
      state.data = payload;
    },
    APPEND: function APPEND(state, payload) {
      state.data = state.data.concat(payload);
    },
    EDIT: function EDIT(state, payload) {
      var index = state.data.findIndex(function (visit) {
        return visit.id === payload.id;
      });
      if (index > -1) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.data, index, payload);
      }
    },
    ADD: function ADD(state, payload) {
      state.data.unshift(payload);
    },
    DELETE: function DELETE(state, id) {
      state.delete = false;
      var index = state.data.findIndex(function (item) {
        return item.id === id;
      });
      if (index > -1) {
        state.data.splice(index, 1);
      }
    },
    DIALOG: function DIALOG(state, payload) {
      state.dialog = payload;
    },
    FILTER: function FILTER(state, payload) {
      state.filter = payload;
    },
    TAB: function TAB(state, payload) {
      state.tab = payload;
    }
  },

  getters: {
    statusById: function statusById(state) {
      var objectById = {};
      state.status !== null && state.status.forEach(function (item) {
        objectById[item.id] = item;
      });
      return objectById;
    },

    status: function status(state, getters) {
      return function (id) {
        return getters.statusById[id] ? getters.statusById[id] : { name: '- Nedefinit -' };
      };
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    data: [],
    employee: {}
  },

  actions: {
    LOAD: function LOAD(_ref, _ref2) {
      var commit = _ref.commit;
      var filter = _ref2.filter;

      var params = {};
      if (filter) {
        for (var key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = filter.sortBy + ':' + (filter.descending ? 'DESC' : 'ASC');
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/employees', { params: params }).then(function (response) {
          return response.data;
        }).then(function (response) {
          commit('EMPLOYEES', response.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    LOAD_ONE: function LOAD_ONE(_ref3, id) {
      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/employees/' + id).then(function (response) {
          return response.data;
        }).then(function (response) {
          commit('EMPLOYEE', response.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    DELETE: function DELETE(_ref4, id) {
      var commit = _ref4.commit;

      commit('DELETE', id);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/employees/' + id).then(function (response) {
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    EDIT: function EDIT(_ref5, data) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/employees/' + data.id, data).then(function (response) {
          commit('EDIT', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    ADD: function ADD(_ref6, data) {
      var commit = _ref6.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/employees/', data).then(function (response) {
          commit('ADD', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },

  mutations: {
    EMPLOYEES: function EMPLOYEES(state, payload) {
      state.data = payload;
    },
    EMPLOYEE: function EMPLOYEE(state, payload) {
      state.employee = payload;
    },
    EDIT: function EDIT(state, payload) {
      var index = state.data.findIndex(function (employee) {
        return employee.id === payload.id;
      });
      if (index > -1) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.data, index, payload);
      }
    },
    ADD: function ADD(state, payload) {
      state.data.unshift(payload);
    },
    DELETE: function DELETE(state, id) {
      var index = state.data.findIndex(function (item) {
        return item.id === id;
      });
      if (index > -1) {
        state.data.splice(index, 1);
      }
    }
  },

  getters: {}
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    data: [],
    machine: {}
  },

  actions: {
    LOAD: function LOAD(_ref, _ref2) {
      var commit = _ref.commit;
      var filter = _ref2.filter;

      var params = {};
      if (filter) {
        for (var key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = filter.sortBy + ':' + (filter.descending ? 'DESC' : 'ASC');
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/machines', { params: params }).then(function (response) {
          return response.data;
        }).then(function (response) {
          commit('MACHINES', response.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    LOAD_ONE: function LOAD_ONE(_ref3, id) {
      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/machines/' + id).then(function (response) {
          return response.data;
        }).then(function (response) {
          commit('MACHINES', [response.data]);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    DELETE: function DELETE(_ref4, id) {
      var commit = _ref4.commit;

      commit('DELETE', id);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/machines/' + id).then(function (response) {
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    EDIT: function EDIT(_ref5, data) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/machines/' + data.id, data).then(function (response) {
          commit('EDIT', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    ADD: function ADD(_ref6, data) {
      var commit = _ref6.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        delete data.id;
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/machines/', data).then(function (response) {
          commit('ADD', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },

  mutations: {
    MACHINES: function MACHINES(state, payload) {
      state.data = payload;
    },
    MACHINE: function MACHINE(state, payload) {
      state.machine = payload;
    },
    EDIT: function EDIT(state, payload) {
      var index = state.data.findIndex(function (employee) {
        return employee.id === payload.id;
      });
      if (index > -1) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.data, index, payload);
      }
    },
    ADD: function ADD(state, payload) {
      state.data.unshift(payload);
    },
    DELETE: function DELETE(state, id) {
      var index = state.data.findIndex(function (item) {
        return item.id === id;
      });
      if (index > -1) {
        state.data.splice(index, 1);
      }
    }
  },

  getters: {}
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    data: [],
    status: [{ id: 0, name: 'De făcut', icon: 'check_box_outline_blank', color: 'red' }, { id: 1, name: 'Făcut', icon: 'check_box', color: 'green' }]
  },

  actions: {
    LOAD: function LOAD(_ref, _ref2) {
      var commit = _ref.commit,
          state = _ref.state,
          rootGetters = _ref.rootGetters;
      var filter = _ref2.filter;

      var params = {};
      if (filter) {
        for (var key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = filter.sortBy + ':' + (filter.descending ? 'DESC' : 'ASC');
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/visit-actions', { params: params }).then(function (response) {
          return response.data;
        }).then(function (response) {
          commit('VISIT_ACTIONS', response.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    DELETE: function DELETE(_ref3, id) {
      var commit = _ref3.commit;

      commit('DELETE', id);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/visit-actions/' + id).then(function (response) {
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    EDIT: function EDIT(_ref4, data) {
      var commit = _ref4.commit,
          rootState = _ref4.rootState,
          rootGetters = _ref4.rootGetters;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/visit-actions/' + data.id, data).then(function (response) {
          return response.data;
        }).then(function (response) {
          response.data.path = rootGetters['actions/action'](response.data.action.id).path;
          commit('EDIT', response.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    ADD: function ADD(_ref5, data) {
      var commit = _ref5.commit,
          rootState = _ref5.rootState,
          rootGetters = _ref5.rootGetters;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/visit-actions', data).then(function (response) {
          return response.data;
        }).then(function (response) {
          response.data.path = rootGetters['actions/action'](response.data.action.id).path;
          commit('ADD', response.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },

  mutations: {
    VISIT_ACTIONS: function VISIT_ACTIONS(state, payload) {
      state.data = payload;
    },
    EDIT: function EDIT(state, payload) {
      var index = state.data.findIndex(function (item) {
        return item.id === payload.id;
      });
      if (index > -1) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.data, index, payload);
      }
    },
    ADD: function ADD(state, payload) {
      state.data.unshift(payload);
    },
    DELETE: function DELETE(state, id) {
      var index = state.data.findIndex(function (item) {
        return item.id === id;
      });
      if (index > -1) {
        state.data.splice(index, 1);
      }
    }
  },

  getters: {
    statusById: function statusById(state) {
      var objectById = {};
      state.status !== null && state.status.forEach(function (item) {
        objectById[item.id] = item;
      });
      return objectById;
    },

    status: function status(state, getters) {
      return function (id) {
        return getters.statusById[id];
      };
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);








function addChildren(obj, node) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(obj), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var elm = _step.value;

      if (elm.id === node.parent_id) {
        if (typeof elm.children === 'undefined') {
          elm.children = [];
        }
        elm.children.push(node);
      } else if (elm.children) {
        addChildren(elm.children, node);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

function appendNode(node, data, state) {
  if (node.parent_id === 0) {
    return;
  }
  var parent = state.data.find(function (n) {
    return n.id === node.parent_id;
  });
  if (typeof data.find(function (d) {
    return d.id === parent.id;
  }) === 'undefined') {
    data.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, parent));
  }
  appendNode(parent, data, state);
};

function deleteChildren(state, id) {
  var index = state.data.findIndex(function (n) {
    return n.id === id;
  });
  if (index === -1) {
    return;
  }
  state.data.splice(index, 1);
  var child = state.data.find(function (n) {
    return n.parent_id === id;
  });
  if (child) {
    deleteChildren(state, child.id);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    data: [],
    selectedItem: null,
    filter: '',
    dialog: null
  },

  actions: {
    LOAD: function LOAD(_ref, _ref2) {
      var commit = _ref.commit;
      var filter = _ref2.filter;

      var params = {};
      if (filter) {
        for (var key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = filter.sortBy + ':' + (filter.descending ? 'DESC' : 'ASC');
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;
      }
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4__axios__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* SERVER_URL */] + '/api/actions', { params: params }).then(function (response) {
          return response.data;
        }).then(function (response) {
          commit('ACTIONS', response.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    EDIT: function EDIT(_ref3, data) {
      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4__axios__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* SERVER_URL */] + '/api/actions/' + data.id, data).then(function (response) {
          commit('EDIT', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    ADD: function ADD(_ref4, data) {
      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        delete data.id;
        __WEBPACK_IMPORTED_MODULE_4__axios__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* SERVER_URL */] + '/api/actions/', data).then(function (response) {
          commit('ADD', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    DELETE: function DELETE(_ref5, id) {
      var commit = _ref5.commit;

      commit('DELETE', id);
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4__axios__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* SERVER_URL */] + '/api/actions/' + id).then(function (response) {
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },

  mutations: {
    ACTIONS: function ACTIONS(state, payload) {
      state.data = payload;
    },
    EDIT: function EDIT(state, payload) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(state.data.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref6 = _step2.value;

          var _ref7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref6, 2);

          var index = _ref7[0];
          var value = _ref7[1];

          if (value.id === payload.id) {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.data, index, payload);
            state.selectedItem.name = payload.name;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    ADD: function ADD(state, payload) {
      state.data.unshift(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, payload));
    },
    DELETE: function DELETE(state, id) {
      state.selectedItem = null;
      deleteChildren(state, id);
    },
    SELECT: function SELECT(state, payload) {
      state.selectedItem = payload;
    },
    FILTER: function FILTER(state, payload) {
      state.filter = payload;
      if (payload) {
        state.selectedItem = null;
      }
    },
    DIALOG: function DIALOG(state, payload) {
      state.dialog = payload;
    }
  },

  getters: {
    tree: function tree(state) {
      var obj = [];
      var data = state.data.slice(0);
      if (state.filter) {
        data = data.filter(function (node) {
          return node.name.toUpperCase().includes(state.filter.toUpperCase());
        });
        data.map(function (node) {
          appendNode(node, data, state);
        });
      }

      data.sort(function (a, b) {
        if (a.parent_id - b.parent_id === 0) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        } else if (a.parent_id - b.parent_id < 0) {
          return -1;
        } else if (a.parent_id - b.parent_id > 0) {
          return 1;
        }
      }).map(function (node) {
        if (node.parent_id === 0) {
          obj.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, node, { children: [] }));
        } else {
          addChildren(obj, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, node));
        }
      });
      return obj;
    },

    action: function action(state, getters) {
      return function (id) {
        var action = state.data.find(function (f) {
          return f.id === id;
        });
        if (action) {
          action.path = '';
          var data = [];
          appendNode(action, data, state);
          data.reverse();
          data.forEach(function (element) {
            action.path = '' + action.path + element.name + '  > ';
          });
          action.path = '' + action.path + action.name;
          return action;
        }
        return {
          id: -1,
          path: '- nedefinit -'
        };
      };
    }
  }
});

/***/ }),
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    data: []
  },

  actions: {
    LOAD: function LOAD(_ref, _ref2) {
      var commit = _ref.commit;
      var filter = _ref2.filter;

      var params = {};
      if (filter) {
        for (var key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = filter.sortBy + ':' + (filter.descending ? 'DESC' : 'ASC');
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/agencies', { params: params }).then(function (response) {
          return response.data;
        }).then(function (response) {
          commit('AGENCIES', response.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    DELETE: function DELETE(_ref3, id) {
      var commit = _ref3.commit;

      commit('DELETE', id);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/agencies/' + id).then(function (response) {
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    EDIT: function EDIT(_ref4, data) {
      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/agencies/' + data.id, data).then(function (response) {
          commit('EDIT', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    ADD: function ADD(_ref5, data) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        delete data.id;
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/agencies/', data).then(function (response) {
          commit('ADD', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },

  mutations: {
    AGENCIES: function AGENCIES(state, payload) {
      state.data = payload;
    },
    EDIT: function EDIT(state, payload) {
      var index = state.data.findIndex(function (employee) {
        return employee.id === payload.id;
      });
      if (index > -1) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.data, index, payload);
      }
    },
    ADD: function ADD(state, payload) {
      state.data.unshift(payload);
    },
    DELETE: function DELETE(state, id) {
      var index = state.data.findIndex(function (item) {
        return item.id === id;
      });
      if (index > -1) {
        state.data.splice(index, 1);
      }
    }
  },

  getters: {}
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    data: []
  },

  actions: {
    LOAD: function LOAD(_ref, _ref2) {
      var commit = _ref.commit;
      var filter = _ref2.filter;

      var params = {};
      if (filter) {
        for (var key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = filter.sortBy + ':' + (filter.descending ? 'DESC' : 'ASC');
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/clients', { params: params }).then(function (response) {
          return response.data;
        }).then(function (response) {
          commit('CLIENTS', response.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    DELETE: function DELETE(_ref3, id) {
      var commit = _ref3.commit;

      commit('DELETE', id);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/clients/' + id).then(function (response) {
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    EDIT: function EDIT(_ref4, data) {
      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].put(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/clients/' + data.id, data).then(function (response) {
          commit('EDIT', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    ADD: function ADD(_ref5, data) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/clients/', data).then(function (response) {
          commit('ADD', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },

  mutations: {
    CLIENTS: function CLIENTS(state, payload) {
      state.data = payload;
    },
    EDIT: function EDIT(state, payload) {
      var index = state.data.findIndex(function (employee) {
        return employee.id === payload.id;
      });
      if (index > -1) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.data, index, payload);
      }
    },
    ADD: function ADD(state, payload) {
      state.data.unshift(payload);
    },
    DELETE: function DELETE(state, id) {
      var index = state.data.findIndex(function (item) {
        return item.id === id;
      });
      if (index > -1) {
        state.data.splice(index, 1);
      }
    }
  },

  getters: {}
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    data: []
  },

  actions: {
    LOAD: function LOAD(_ref, _ref2) {
      var commit = _ref.commit;
      var filter = _ref2.filter;

      var params = {};
      if (filter) {
        for (var key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = filter.sortBy + ':' + (filter.descending ? 'DESC' : 'ASC');
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/client-locations', { params: params }).then(function (response) {
          return response.data;
        }).then(function (response) {
          commit('CLIENT_LOCATIONS', response.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    LOAD_ONE: function LOAD_ONE(_ref3, id) {
      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/client-locations/' + id).then(function (response) {
          return response.data;
        }).then(function (response) {
          commit('CLIENT_LOCATIONS', [response.data]);
          resolve(response.data);
        }, function (error) {
          reject(error);
        });
      });
    },
    DELETE: function DELETE(_ref4, id) {
      var commit = _ref4.commit;

      commit('DELETE', id);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/client-locations/' + id).then(function (response) {
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    EDIT: function EDIT(_ref5, data) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/client-locations/' + data.id, data).then(function (response) {
          commit('EDIT', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    ADD: function ADD(_ref6, data) {
      var commit = _ref6.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        delete data.id;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/client-locations/', data).then(function (response) {
          commit('ADD', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },

  mutations: {
    CLIENT_LOCATIONS: function CLIENT_LOCATIONS(state, payload) {
      state.data = payload;
    },
    EDIT: function EDIT(state, payload) {
      var index = state.data.findIndex(function (employee) {
        return employee.id === payload.id;
      });
      if (index > -1) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.data, index, payload);
      }
    },
    ADD: function ADD(state, payload) {
      state.data.unshift(payload);
    },
    DELETE: function DELETE(state, id) {
      var index = state.data.findIndex(function (item) {
        return item.id === id;
      });
      if (index > -1) {
        state.data.splice(index, 1);
      }
    }
  },

  getters: {
    clientLocationById: function clientLocationById(state) {
      var objectById = {};
      state.data !== null && state.data.forEach(function (item) {
        objectById[item.id] = item;
      });
      return objectById;
    },

    clientLocation: function clientLocation(state, getters) {
      return function (id) {
        return getters.clientLocationById[id] ? getters.clientLocationById[id] : { name: '- Nedefinit -' };
      };
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    data: [],
    tva: [{ id: '0.00', name: '0%' }, { id: '9.00', name: '9%' }, { id: '19.00', name: '19%' }]
  },

  actions: {
    LOAD: function LOAD(_ref, _ref2) {
      var commit = _ref.commit;
      var filter = _ref2.filter;

      var params = {};
      var download = false;
      if (filter) {
        for (var key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = filter.sortBy + ':' + (filter.descending ? 'DESC' : 'ASC');
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;

        download = filter.hasOwnProperty('_download_');
        if (download) {
          params.rowsPerPage = -1;
        }
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/products', {
          params: params,
          responseType: download ? 'arraybuffer' : 'json'
        }).then(function (response) {
          return response.data;
        }).then(function (response) {
          if (!download) {
            commit('PRODUCTS', response.data);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    LOAD_ONE: function LOAD_ONE(_ref3, id) {
      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/products/' + id).then(function (response) {
          return response.data;
        }).then(function (response) {
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    DELETE: function DELETE(_ref4, id) {
      var commit = _ref4.commit;

      commit('DELETE', id);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/products/' + id).then(function (response) {
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    EDIT: function EDIT(_ref5, data) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/products/' + data.id, data).then(function (response) {
          commit('EDIT', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    ADD: function ADD(_ref6, data) {
      var commit = _ref6.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/products/', data).then(function (response) {
          commit('ADD', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },

  mutations: {
    PRODUCTS: function PRODUCTS(state, payload) {
      state.data = payload;
    },
    EDIT: function EDIT(state, payload) {
      var index = state.data.findIndex(function (product) {
        return product.id === payload.id;
      });
      if (index > -1) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.data, index, payload);
      }
    },
    ADD: function ADD(state, payload) {
      state.data.unshift(payload);
    },
    DELETE: function DELETE(state, id) {
      var index = state.data.findIndex(function (item) {
        return item.id === id;
      });
      if (index > -1) {
        state.data.splice(index, 1);
      }
    }
  },

  getters: {}
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    data: [],
    locations: [{ id: 1, name: 'Depozit' }, { id: 2, name: 'Tehnician' }, { id: 3, name: 'Aparat' }],
    status: [{ id: 1, name: 'bună' }, { id: 2, name: 'de test' }, { id: 3, name: 'de aruncat' }]
  },

  actions: {
    LOAD: function LOAD(_ref, _ref2) {
      var commit = _ref.commit;
      var filter = _ref2.filter;

      var params = {};
      var download = false;
      if (filter) {
        for (var key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = filter.sortBy + ':' + (filter.descending ? 'DESC' : 'ASC');
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;

        download = filter.hasOwnProperty('_download_');
        if (download) {
          params.rowsPerPage = -1;
        }
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/stock', {
          params: params,
          responseType: download ? 'arraybuffer' : 'json'
        }).then(function (response) {
          return response.data;
        }).then(function (response) {
          if (!download) {
            commit('STOCK', response.data);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    LOAD_ONE: function LOAD_ONE(_ref3, id) {
      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/stock/' + id).then(function (response) {
          return response.data;
        }).then(function (response) {
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    DELETE: function DELETE(_ref4, id) {
      var commit = _ref4.commit;

      commit('DELETE', id);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/stock/' + id).then(function (response) {
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    EDIT: function EDIT(_ref5, data) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/stock/' + data.id, data).then(function (response) {
          commit('EDIT', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    ADD: function ADD(_ref6, data) {
      var commit = _ref6.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        delete data.id;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SERVER_URL */] + '/api/stock/', data).then(function (response) {
          commit('ADD', response.data.data);
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },

  mutations: {
    STOCK: function STOCK(state, payload) {
      state.data = payload;
    },
    EDIT: function EDIT(state, payload) {
      var index = state.data.findIndex(function (item) {
        return item.id === payload.id;
      });
      if (index > -1) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.data, index, payload);
      }
    },
    ADD: function ADD(state, payload) {
      state.data.unshift(payload);
    },
    DELETE: function DELETE(state, id) {
      var index = state.data.findIndex(function (item) {
        return item.id === id;
      });
      if (index > -1) {
        state.data.splice(index, 1);
      }
    }
  },

  getters: {
    statusById: function statusById(state) {
      var objectById = {};
      state.status !== null && state.status.forEach(function (item) {
        objectById[item.id] = item;
      });
      return objectById;
    },

    locationById: function locationById(state) {
      var objectById = {};
      state.locations !== null && state.locations.forEach(function (item) {
        objectById[item.id] = item;
      });
      return objectById;
    },

    status: function status(state, getters) {
      return function (id) {
        return getters.statusById[id] ? getters.statusById[id] : { name: '- Nedefinit -' };
      };
    },

    location: function location(state, getters) {
      return function (id) {
        return getters.locationById[id] ? getters.locationById[id] : { name: '- Nedefinit -' };
      };
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79a92bff_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(325);
function injectStyle (ssrContext) {
  __webpack_require__(322)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79a92bff_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Default_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74320f86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Default_vue__ = __webpack_require__(324);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Default_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74320f86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Default_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.pageTitle && _vm.pageTitle !== 'Login')?_c('v-navigation-drawer',{attrs:{"clipped":_vm.$vuetify.breakpoint.lgAndUp,"fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.items),function(item){return [(item.heading)?_c('v-layout',{key:item.heading,attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs6":""}},[(item.heading)?_c('v-subheader',[_vm._v("\n              "+_vm._s(item.heading)+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs6":""}},[_c('a',{staticClass:"body-2 black--text",attrs:{"href":"#!"}},[_vm._v("EDIT")])])],1):(item.children)?_c('v-list-group',{key:item.text,attrs:{"prepend-icon":item.model ? item.icon : item['icon-alt'],"append-icon":""},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(item.text)+"\n              ")])],1)],1),_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-tile',{key:i,attrs:{"to":child.href}},[(child.icon)?_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(child.icon))])],1):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(child.text)+"\n              ")])],1)],1)})],2):_c('v-list-tile',{key:item.text,attrs:{"to":item.href}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(item.text)+"\n            ")])],1)],1)]})],2)],1):_vm._e(),_vm._v(" "),_c('v-toolbar',{attrs:{"clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"color":"pink","dark":"","app":"","fixed":"","tabs":""}},[(_vm.pageTitle)?_c('v-toolbar-title',{staticClass:"ml-0 pl-3",staticStyle:{"width":"300px"}},[(_vm.pageTitle !== 'Login')?_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.pageTitle))])],1):_vm._e(),_vm._v(" "),(!_vm.pageTitle  && _vm.$route.name !== 'NoInternetConnection')?_c('v-btn',{staticClass:"ml-0",attrs:{"flat":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.back()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")])],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.pageTitle && _vm.pageTitle === 'Vizite')?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.onAction('filter')}}},[_c('v-icon',[_vm._v("filter_list")])],1):_vm._e(),_vm._v(" "),(!_vm.pageTitle && _vm.$route.name !== 'NoInternetConnection')?[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.onAction('add')}}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.actions),function(item,index){return _c('v-list-tile',{key:index,on:{"click":function($event){_vm.onAction(item.id)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.text))])],1)}))],1)]:_vm._e(),_vm._v(" "),(_vm.pageTitle && _vm.pageTitle === 'Vizite')?_c('v-tabs',{attrs:{"slot":"extension","color":"pink","grow":""},slot:"extension",model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_vm._l((_vm.$store.state.visits.tabItems),function(item){return _c('v-tab',{key:item.id,class:{ activeClass : item.id === _vm.tab }},[_vm._v("\n        "+_vm._s(item.text)+"\n      ")])})],2):_vm._e()],2),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":"","fill-height":_vm.$store.state.centerViewVertical}},[_c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1),_vm._v(" "),_c('toast-message'),_vm._v(" "),_c('confirmation-dialog')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c(_vm.component,{tag:"component"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 326 */,
/* 327 */,
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__(204);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48859e50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(330);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48859e50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size,"width":_vm.width,"color":"pink"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmationDialog_vue__ = __webpack_require__(205);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63ef0ec5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmationDialog_vue__ = __webpack_require__(332);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmationDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63ef0ec5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmationDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"400"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }return _vm.onCancel($event)}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.onCancel($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){return _vm.onOk($event)}}},[_vm._v(_vm._s(_vm.actionButton))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToastMessage_vue__ = __webpack_require__(206);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78072a40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToastMessage_vue__ = __webpack_require__(334);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToastMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78072a40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToastMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"timeout":6000,"color":_vm.error ? 'error':''},model:{value:(_vm.messageOn),callback:function ($$v) {_vm.messageOn=$$v},expression:"messageOn"}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n  "),_c('v-btn',{attrs:{"flat":"","color":_vm.error ? '': 'blue'},nativeOn:{"click":function($event){_vm.messageOn = false; _vm.message = '';}}},[_vm._v("Close")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditDialog_vue__ = __webpack_require__(207);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e81c7822_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditDialog_vue__ = __webpack_require__(341);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e81c7822_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatePicker_vue__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289b54b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DatePicker_vue__ = __webpack_require__(337);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289b54b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DatePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-menu',{ref:"dateDialog",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.dateDialog),callback:function ($$v) {_vm.dateDialog=$$v},expression:"dateDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","value":_vm.pickerValue,"label":_vm.label,"readonly":""},slot:"activator"}),_vm._v(" "),_c('v-date-picker',{model:{value:(_vm.pickerValue),callback:function ($$v) {_vm.pickerValue=$$v},expression:"pickerValue"}})],1)],1),_vm._v(" "),_c('v-flex',[_c('v-menu',{ref:"timeDialog",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(_vm.timeDialog),callback:function ($$v) {_vm.timeDialog=$$v},expression:"timeDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","value":_vm.timePickerValue,"label":"Ora","readonly":""},slot:"activator"}),_vm._v(" "),_c('v-time-picker',{model:{value:(_vm.timePickerValue),callback:function ($$v) {_vm.timePickerValue=$$v},expression:"timePickerValue"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductSearch_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2c5d10_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductSearch_vue__ = __webpack_require__(340);
function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2c5d10_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-text-field',{ref:"product",attrs:{"label":_vm.label ? _vm.label : '',"loading":_vm.loading,"clearable":"","error":_vm.error,"error-messages":_vm.errorMessages},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),(_vm.dialog)?_c('v-dialog',{attrs:{"fullscreen":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('v-text-field',{ref:"productSearch",attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{ref:"table",attrs:{"headers":_vm.headers,"items":_vm.items,"pagination":_vm.pagination,"total-items":_vm.totalItems,"loading":_vm.loading,"rows-per-page-items":_vm.rowsPerPageItems,"rows-per-page-text":"Rezultate pe pagină","disable-initial-sort":"","item-key":"id","hide-actions":!_vm.hasPagination,"no-data-text":"Nu există date"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{attrs:{"active":props.selected},on:{"click":function($event){props.selected = true}}},_vm._l((_vm.headers),function(header,index){return _c('td',{key:index,staticClass:"line-height-2",domProps:{"innerHTML":_vm._s(_vm.displayRowData(props, header))}})}))]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Anulează")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","loading":_vm.processing,"disabled":_vm.processing || _vm.items.length === 0},nativeOn:{"click":function($event){_vm.onProductSelect()}}},[_vm._v("\n            Selectează\n        ")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"width":!_vm.isMobile ? '60%' : '',"persistent":!_vm.isMobile,"fullscreen":_vm.isMobile,"hide-overlay":_vm.isMobile,"transition":_vm.isMobile ? 'dialog-bottom-transition':''},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('v-toolbar',{attrs:{"dark":"","color":"pink","card":"","fixed":""}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),(_vm.isEditMode)?_c('v-toolbar-title',[_vm._v("Editare "+_vm._s(_vm.entityName))]):_c('v-toolbar-title',[_vm._v("Adaugă "+_vm._s(_vm.entityName))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":"","loading":_vm.processing,"disabled":_vm.processing},nativeOn:{"click":function($event){_vm.onDialogSave()}}},[_vm._v("Save")])],1)],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","mt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.errorMessageGeneric)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"type":"error"}},[_vm._v(_vm._s(_vm.errorMessageGeneric))])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.fields),function(field,index){return _c('v-flex',_vm._b({key:index,attrs:{"xs12":""}},'v-flex',( _obj = {}, _obj[field.size] = true, _obj ),false),[(_vm.shouldShow(field))?_c(field.type,{tag:"component",attrs:{"field":field,"data":_vm.data,"label":field.label,"items":field.options,"item-value":"id","item-text":field.itemText ? field.itemText : 'name',"persistent-hint":(_vm.isEditMode && field.inputType === 'password') || field.persistentHint,"hint":(_vm.isEditMode && field.inputType === 'password') ? 'Completează acest câmp doar dacă vrei să schimbi parola': field.hint,"error":!!_vm.errorMessages.length && field.value in _vm.errorMessages,"error-messages":_vm.dialogErrorMessage(field.value),"errors":_vm.dialogErrorMessage(field.value),"type":field.inputType,"box":field.box,"apiEndpoint":field.apiEndpoint,"required":field.required},model:{value:(_vm.data[field.value]),callback:function ($$v) {_vm.$set(_vm.data, field.value, $$v)},expression:"data[field.value]"}}):_vm._e()],1)
var _obj;})],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[210]);


// WEBPACK FOOTER //
// static/js/app.9bb68d0cd172a3611c03.js